interface IReferenceIcon { style: 'regular' | 'solid'; name: string; }


/**------------------------------------------------------
 * All Hobby Categories Enums
 */
export enum EnumHobbyCategory {
	MakeMoney 		= 'make_money',
	Cheap			= 'cheap',
	ForMen			= 'for_men',
	ForCouples		= 'for_couples',
	ForFamily		= 'for_family',
	Indoor			= 'indoor',
	Your20s			= 'for_your_20_s',
	Your30s			= 'for_your_30_s',
	Retired			= 'over_50_retired',
	Fun				= 'fun',
	Cool			= 'cool',
	Unique			= 'unique',
	ForWomen		= 'for_women',
	Creative		= 'creative',
	Interesting 	= 'interesting',
	Expensive		= 'expensive'
}


/**------------------------------------------------------
 * Hobby List Config Data
 * -------------------------------------
 * > source : https://www.mantelligence.com/list-of-hobbies/
 */
export const HOBBIES_LIST: IHobbyList[] = [
	{
		category 	: {
			category 		: EnumHobbyCategory.MakeMoney,
			name 			: `Make Money`,
			icon 			: {
				style 		: 'regular',
				name 		: `sack-dollar`
			}
		},
		hobbies 	: [
			{
				title 		: `Writing / Blogging`,
				description : `Blogging is the process of writing a blog, or an online journal to share your thoughts about a particular subject with readers. An example of blogging is when you write an online journal about the progress of cooking.`,
				keywords	: `blogging`
			},
			{
				title 		: `Baking`,
				description : `Baking is a way of being creative and an activity to share with our family. We love experimenting with new flavours and creating one of a kind recipes.`,
				keywords	: `baking`
			},
			{
				title 		: `Refinishing Furniture`,
				description : `Refinishing old or antique wooden furniture is a popular hobby. It's a creative and rewarding Do It Yourself (DIY) project.`,
				keywords	: `refinishing furniture`
			},
			{
				title 		: `Flea Market Shopping`,
				description : `A flea market is an outdoor market with stalls that sell second-hand or old goods cheaply. We also call it a swap meet. Many flea markets today also sell baked goods and local farm produce.`,
				keywords	: `flea market shopping`
			},
			{
				title 		: `Catering`,
				description : `Catering is a hobby, providing a supply of food to cater for a large party. Supply what is required or desired catering to middle-class tastes, to provide food.`,
				keywords	: `catering`
			},
			{
				title 		: `Making Music`,
				description : `Making music is far more than just a pleasant pastime. Anyone who plays music goes on a fulfilling journey of emotion, sound, focus, persistence and learning.`,
				keywords	: `making music`
			},
			{
				title 		: `Bartending`,
				description : `It's Fun People who pursue bartending jobs are looking for a fun job. Even though they work behind the bar, it's still an active job.`,
				keywords	: `bartending`
			},
			{
				title 		: `Wine Making`,
				description : `Wine making explains wine grape species and varieties, equipment and chemicals, other ingredients, and processes for producing wine at home.`,
				keywords	: `wine making`
			},
			{
				title 		: `Stock Trading`,
				description : `Stock trading involves buying and selling stocks frequently in an attempt to make money. The goal of stock traders is to capitalize on short-term market events to sell stocks for a profit.`,
				keywords	: `stock trading`
			},
			{
				title 		: `Taking Paid Surveys`,
				description : `Did you know you can get paid to take online surveys? Right from the comfort of your couch, you get paid to do surveys online.`,
				keywords	: `taking surveys`
			},
			{
				title 		: `Beekeeping`,
				description : `Beekeeping is the maintenance of bee colonies. Most such bees are honey bees in the genus Apis, but other honey-producing bees such as Melipona stingless bees are also kept.`,
				keywords	: `beekeeping`
			},
			{
				title 		: `Public Speaking`,
				description : `Businesses need people who can speak to groups, either to introduce products or to make group sales pitches. There are for example opportunities working as a speaker for videos.`,
				keywords	: `public speaking`
			},
			{
				title 		: `Programming`,
				description : `Programming is a career and a engaging hobby for developers. Software developers user a variety of programming languages and tools to create software application and projects for basically everything.`,
				keywords	: `programming`
			},
			{
				title 		: `Proofreading And Editing`,
				description : `Proofreader look for misspellings, incorrect/missed punctuation, inconsistencies, and more. Editing, on the other hand, corrects issues at the core of writing like sentence construction and language clarity.`,
				keywords	: `proofreading`
			},
			{
				title 		: `Coding`,
				description : `Studies show that for the majority of truly successful professional programmers coding is more than just a job. According to Stack Overflow's Developer Survey, about 80% of all developers say that they code as a hobby.`,
				keywords	: `coding`
			},
			{
				title 		: `Tattooing`,
				description : `Tattoos do not need to be replaced or upgraded. Tattoos can be found in the most unique styles anywhere and everywhere, it is a hobby for many people.`,
				keywords	: `tattooing`
			},
			{
				title 		: `Performing Stand Up Comedy`,
				description : `Some people are natural-born comedians and the live it like a lifestyle. If you want to profit while you make people laugh, take your comedic venture to clubs.`,
				keywords	: `stand up comedy`
			},
			{
				title 		: `Drive Others Around`,
				description : `Driving can be a relaxing and fun hobby, especially when done in the right way. Uber and other services offer people the chance to earn money with driving.`,
				keywords	: `taxi driving`
			},
			{
				title 		: `Graphic Design`,
				description : `Designs are used for nearly everything, for ads, shirts and much much more. Website design and logo are one of the most common work among designers.`,
				keywords	: `graphic design`
			},
			{
				title 		: `Making T-Shirts`,
				description : `Are you creative for friends and family? Then selling T-Shirts in print on demand is a good way to make money for your.`,
				keywords	: `pod business`
			},
			{
				title 		: `Becoming A Fitness Instructor`,
				description : `If you are a fitness fan, you may be able to start making some money at it. Basically everyone can quickly become a personal trainer. Gym's with personal trainers all across the country.`,
				keywords	: `personal trainer`
			},
			{
				title 		: `Starting A YouTube Channel`,
				description : `If YouTube is a hobby for you, you can still have fun creating videos and uploading them to be part of the creator community. Being influencer can even become a full time job for many people.`,
				keywords	: `youtube influencer`
			},
			{
				title 		: `Being A Handyman`,
				description : `A handyman, also known as a fixer, handyperson or handyworker, is a person skilled at a wide range of repairs, typically around the home. These tasks include trade skills, repair work, maintenance work, are both interior and exterior.`,
				keywords	: `handyman`
			},
			{
				title 		: `Decorating Homes`,
				description : `Anyone who has ever decorated home or office has taken part in interior design. It's a popular topic for many home and garden entertainment television shows. It is a popular hobby for many people.`,
				keywords	: `decorating homes`
			},
			{
				title 		: `Pet Sitting`,
				description : `Since hobby pet sitters aren't running a business, it's more likely they will not want to take on visits during holidays or whenever they're simply unavailable. Oftentimes, pet sitting isn't just a one time job.`,
				keywords	: `pet sitting`
			},
			{
				title 		: `Flipping Items`,
				description : `Flipping an item just means buying an item for a good price and selling it for more elsewhere. Generally, you buy items used and sell them online. Some people even flip items for a living, making enough to quit their full time jobs.`,
				keywords	: `flipping items`
			},
			{
				title 		: `Becoming A Local Guide`,
				description : `As a Local Guide, a person earns when sharing reviews, photos, and knowledge on Google Maps. Those points lead to higher levels of the program and benefits if a variety of ways.`,
				keywords	: `local guide`
			},
			{
				title 		: `Social Media influencer`,
				description : `People who spend a lot of time on the social media may very well be able to turn that hobby into a moneymaker. Businesses are increasingly recognizing its value as a means of promoting their products and services.`,
				keywords	: `influencer`
			},
			{
				title 		: `Buying And Selling`,
				description : `If you like shopping for bargains, at garage sales, swap meets, estate sales, and around the web, and you have some sort of handle on that "buy-low, sell high" thing, you may be able to begin making money buying and selling the items you come across.`,
				keywords	: `buying and selling`
			},
			{
				title 		: `Credit Card Collecting`,
				description : `Collecting credit cards is a relatively new and rare hobby - some might say unusual. Out of the 2.8 billion credit card users in the world, perhaps only a few thousand collect expired credit cards as a hobby.`,
				keywords	: `credit card collecting`
			},
			{
				title 		: `Engravings`,
				description : `Engraving is the art of cutting or carving a design into a hard surface. With a little patience and a willingness to learn, anyone can enjoy the art of engraving.`,
				keywords	: `engravings`
			},
			{
				title 		: `Computer Technician`,
				description : `Sometimes called computer support specialists, freelance computer technicians install, maintain, and repair computer hardware and software for their clients. Simply put, computer technicians troubleshoot and analyze user problems and implement solutions.`,
				keywords	: `computer technician`
			},
			{
				title 		: `Car Tuning`,
				description : `Tuning can include a wide variety of adjustments and modifications, such as the routine adjustment of the carburetor and ignition system to significant engine overhauls.`,
				keywords	: `car tuning`
			},
			{
				title 		: `Yoga Trainer`,
				description : `Whether you want a glowing skin, a fitter body or a relaxed mind, Yoga as a hobby is the perfect way to make time for your health and wellness without the need for any special equipment or a dedicated teacher.`,
				keywords	: `yoga trainer`
			},
			{
				title 		: `Website Optimization`,
				description : `Website Optimization: Website Optimization, also sometimes called Landing Page Optimization or Conversion Rate Optimization is the process by which companies work to improve their websites using design techniques, optimization principles, and experimentation.`,
				keywords	: `webdesigner`
			},
			{
				title 		: `Search Engine Marketing`,
				description : `Search engine marketing is a form of Internet marketing that involves the promotion of websites by increasing their visibility in search engine results pages primarily through paid advertising.`,
				keywords	: `search engine optimization`
			},
			{
				title 		: `Screen Printing`,
				description : `Screen printing is the process of transferring a stencilled design onto a flat surface using a mesh screen, ink and a squeegee. Fabric and paper are the most commonly screen-printed surfaces, but with specialized inks it's also possible to print onto wood, metal, plastic, and even glass.`,
				keywords	: `screen printing`
			},
			{
				title 		: `Home Staging`,
				description : `Staging is designed to showcase a home's best assets, impress buyers, and sell it quickly for the highest possible price. This more or less simple task can become a job.`,
				keywords	: `home staging`
			},
			{
				title 		: `Financial Planning`,
				description : `Financial planning is a step-by-step approach to meet one's life goals. A financial plan acts as a guide as you go through life's journey. Essentially, it helps you be in control of your income, expenses and investments.`,
				keywords	: `financial planning`
			},
			{
				title 		: `Working On Cars`,
				description : `Automotive technicians are service professionals who repair, inspect, and maintain both commercial and privately-owned vehicles.`,
				keywords	: `car mechanic`
			},
			{
				title 		: `Life Coaching`,
				description : `A life coach is a type of wellness professional who helps people make progress in their lives in order to attain greater fulfillment. Life coaches aid their clients in improving their relationships, careers, and day-to-day lives.`,
				keywords	: `life coaching`
			},
			{
				title 		: `Cartooning & Animation`,
				description : `It is like writing a story with the help of animated characters. One can take cartoon drawing as a hobby for fun or as pure pleasure. To develop this skill as a hobby you do not need more than a paper, pencil, a felt tip pen, and a few colored crayons.`,
				keywords	: `cartooning`
			},
			{
				title 		: `Writing Music`,
				description : `Writing a song can help with tapping into the source of certain feelings, especially in areas of love and desire, and coming up with possible solutions, which can further relieve tension and stress.`,
				keywords	: `writing music`
			},
			{
				title 		: `Tutoring Children`,
				description : `Tutoring will prepare others for tests and exams, while tutors work with children, students and even adults on specific problem areas. This then leads to a second income stream for the tutor.`,
				keywords	: `tutoring`
			},
			{
				title 		: `Flower Arranging`,
				description : `Unlike many other hobbies, with flower arranging you can often use flowers and foliage from your own garden, or you can often buy flowers at a good price at a market. These beautiful flowers can then potentially be sold on markets.`,
				keywords	: `flower arranging`
			},
			{
				title 		: `Couponing`,
				description : `Couponing as a hobby in moderation is a great way to make savings on almost a number of stuffs up the store shelves. Saving money by couponing has become a popular hobby around the world.`,
				keywords	: `couponing`
			},
			{
				title 		: `Freelance Photography`,
				description : `Freelance photographer is someone who takes on clients, clicks photographs as per the requirement, and charges them for it. Working as a freelance photographer you market yourself through social media, digital portfolios or websites by displaying your work to find potential clients.`,
				keywords	: `freelance photography`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Cheap,
			name 			: `Cheap`,
			icon 			: {
				style 		: 'solid',
				name 		: `piggy-bank`
			}
		},
		hobbies 	: [
			{
				title 		: `Mobile Technician`,
				description : `Mobile phone repair technicians run tests to assess the mobile phones' functionality, install and update phone software, troubleshoot wiring problems, and replace damaged parts and components such as batteries, LCD screens, keypads, buttons.`,
				keywords	: `mobile technician`
			},
			{
				title 		: `Coaching Local Sports`,
				description : `Sports coach is a person coaching in sport, involved in the direction, instruction and training of a sports team or sports person.`,
				keywords	: `sports coach`
			},
			{
				title 		: `Bicycling / Cycling`,
				description : `Cycling, also called bicycling or biking, is the use of bicycles for transport, recreation, exercise or sport. People engaged in cycling are referred to as "cyclists", "bicyclists", or "bikers".`,
				keywords	: `cycling`
			},
			{
				title 		: `Arts and Crafts`,
				description : `The Arts and Crafts movement was an international trend in the decorative and fine arts that developed earliest and most fully in the British Isles and subsequently spread across the British Empire and to the rest of Europe and America.`,
				keywords	: `arts and crafts`
			},
			{
				title 		: `Genealogy`,
				description : `Genealogy is the study of families, family history, and the tracing of their lineages. Genealogists use oral interviews, historical records, genetic analysis, and other records to obtain information about a family and to demonstrate kinship.`,
				keywords	: `genealogy`
			},
			{
				title 		: `Rock Painting`,
				description : `Anthropologists and archeologists define rock art as images carved, drawn, or painted onto immovable rock surfaces. Images that are carved or engraved into rock are called petroglyphs. Images made with paint or other pigment are called pictographs.`,
				keywords	: `rock painting`
			},
			{
				title 		: `Making Time Capsules`,
				description : `A time capsule is a container that holds present day items, such as photos, newspapers (if you still receive those), letters and more. It's typically hidden away for your future self or someone of your choosing to open. This is perfect as a gift to yourself.`,
				keywords	: `time capsule`
			},
			{
				title 		: `Dog Training`,
				description : `Dog training is the application of behavior analysis which uses the environmental events of antecedents and consequences to modify the dog behavior, either for it to assist in specific activities or undertake particular tasks, or for it to participate effectively in contemporary domestic life.`,
				keywords	: `dog training`
			},
			{
				title 		: `Road Cycling / Biking`,
				description : `Road cycling is the most widespread form of cycling in which cyclists ride on paved roadways. Road bicycles have thinner tires, lighter frames with no suspension, and a set of drop handle bars to allow riders to get in a more aerodynamic position while cycling at higher speeds.`,
				keywords	: `cycling`
			},
			{
				title 		: `Meditation`,
				description : `Meditation is a practice where an individual uses a technique - such as mindfulness, or focusing the mind on a particular object, thought, or activity - to train attention and awareness, and achieve a mentally clear and emotionally calm and stable state.`,
				keywords	: `meditation`
			},
			{
				title 		: `Walking`,
				description : `With extensive benefits for body and mind alike, there's not to take it up as a hobby. Not solely a means of getting from A to B, the benefits of walking are numerous.`,
				keywords	: `walking`
			},
			{
				title 		: `Candle Making`,
				description : `With time, candle making has become an art form. Individuals have their designs and ideas for candles. In this situation, no matter what design is made, it becomes a work of art, at least to the creator.`,
				keywords	: `candle making`
			},
			{
				title 		: `Beachcombing`,
				description : `Beachcombing is an activity that consists of an individual "combing" the beach and the intertidal zone, looking for things of value, interest or utility. A beachcomber is a person who participates in the activity of beachcombing.`,
				keywords	: `beachcombing`
			},
			{
				title 		: `Learn To Sew`,
				description : `Starting a sewing hobby requires some essential supplies. At the least a sewing machine, measuring tools (tape, ruler, etc.), pins, scissors, marking tools (such as a tracing wheel or erasable marker), needles and threaders and, of course, thread.`,
				keywords	: `sewing`
			},
			{
				title 		: `Magic Tricks & Card Tricks`,
				description : `Magic is a wonderfully fulfilling hobby. Learning magic is exciting, fascinating, educational, and develops confidence, social and motor skills. These are often the hobbies of children but can also be a full time job for magicians.`,
				keywords	: `magic tricks`
			},
			{
				title 		: `Watch Documentaries`,
				description : `Documentaries deal exclusively with facts and real-life events. The main purpose of a documentary is to inform and educate. Despite their differences, both feature films and documentaries use cinematography and follow a script.`,
				keywords	: `watch documentaries`
			},
			{
				title 		: `Guerrilla Gardening`,
				description : `Guerrilla gardening is the act of gardening raising food, plants, or flowers on land that the gardeners do not have the legal rights to cultivate, such as abandoned sites, areas that are not being cared for, or private property.`,
				keywords	: `guerrilla gardening`
			},
			{
				title 		: `Learn About Philosophy`,
				description : `When you study philosophy, you develop skills in verbal and written communication, problem solving, clear and disciplined thinking and analysis, along with persuasive argumentation.`,
				keywords	: `philosophy`
			},
			{
				title 		: `Urban Fruit Picking`,
				description : `Urban gardening reduces carbon footprints by reducing carbon emissions during the transportation of food, vegetables, and fruits from other regions or countries. It also relieves the farms where agriculture was traditionally practiced, freeing the land for natural regeneration.`,
				keywords	: `urban gardening`
			},
			{
				title 		: `Minimalism`,
				description : `The idea of minimalism is being mindful and having things that are truly meaningful to you. Minimalism isn't about whittling our belongings down to zero possessions; it's about being intentional about the things we keep.`,
				keywords	: `minimalism`
			},
			{
				title 		: `Journaling`,
				description : `A great hobby, journaling can have a positive impact on your mental health, especially during the colder, darker months. It helps to lower stress levels of everyday life, travel back to your happiest memories, and feel empowered to look upon your past with fondness and joy.`,
				keywords	: `journaling`
			},
			{
				title 		: `Fostering Animals`,
				description : `Fostering pets and animals is one of the latest entries in the list of hobbies. Being a foster parent means opening our homes to an animal in need. Fostering is an amazing way to help give a second chance to animals that need to survive.`,
				keywords	: `fostering pets`
			},
			{
				title 		: `Wikipedia Editor`,
				description : `The open nature of a wiki lets anyone be a Wikipedia editor. However, to be trusted within the Wikipedia community and ensure that contributions stay requires a bit more effort.`,
				keywords	: `wikipedia editor`
			},
			{
				title 		: `Upcycling`,
				description : `Upcycling is the process of repurposing discarded materials or products and turning them into new, higher-quality objects that have artistic or environmental value. It's really one of the most creative hobbies out there.`,
				keywords	: `upcycling`
			},
			{
				title 		: `Reading`,
				description : `Many people don't realize that reading can be a free activity. The main options for free and great reading are: Going To The Library, or Reading Online.`,
				keywords	: `reading`
			},
			{
				title 		: `Making Miniatures`,
				description : `Miniacs are the makers, collectors, and fans of diminutive versions of, well, everything: dime-size dentures or tarot cards as small as pencil shavings.`,
				keywords	: `making miniatures`
			},
			{
				title 		: `Singing`,
				description : `Singing can be another great hobby that doesn't cost anything. The fun part about singing is that you can be as casual or formal as you want with it.`,
				keywords	: `singing`
			},
			{
				title 		: `Tatebanko`,
				description : `Tatebanko is a forgotten Japanese art of creating amazing dioramas and scenic perspective from paper. Typically the diorama is housed inside a paper box and portrays some kind of scene.`,
				keywords	: `tatebanko`
			},
			{
				title 		: `Quilling`,
				description : `Paper quilling is the art of rolling narrow strips of paper into coils or scrolls, and arranging them to form intricate layers or filigree. Paper quilling is not a very difficult skill to master.`,
				keywords	: `quilling`
			},
			{
				title 		: `Container Gardening`,
				description : `Gardening as a hobby that has many advantages. Gardening is a great way to get out, away from your daily routine, and practice your creativity. It is good for your health, no matter how old you are.`,
				keywords	: `container gardening`
			},
			{
				title 		: `Archaeology`,
				description : `People interested in metal detecting focus on finding metal objects and their fragments. Not everyone is interested in the past, but some do search for old objects and archaeological entities.`,
				keywords	: `archaeology`
			},
			{
				title 		: `Playing Chess`,
				description : `Playing Chess is a hobby and so many other things as well. For most non-professional chess players, chess can be seen as a hobby as it is regularly played for enjoyment during one's leisure time.`,
				keywords	: `playing chess`
			},
			{
				title 		: `Learning How To DIY`,
				description : `Do-it-yourself hobbies are one of the most popular hobbies for adults who are crafty. Many adults love being able to create items from scratch. There's a certain type of satisfaction that you get from making something yourself.`,
				keywords	: `diy`
			},
			{
				title 		: `Sudoku`,
				description : `There is something captivating about the simplicity of the nine-by-nine grid that is Sudoku. For some people it is a hobby, but for others it is a challenge that allows them to compete at the global level.`,
				keywords	: `sudoku`
			},
			{
				title 		: `Quizzing`,
				description : `Quizzing comes to rescue in this case too. Nothing can be more benefiting than making quizzing as a hobby. The advantages are immense, since quizzing is one thing that covers all bases i.e it includes information related to all domains.`,
				keywords	: `quizzing`
			},
			{
				title 		: `Noodling`,
				description : `Noodling is fishing for catfish using one's bare hands, and is practiced primarily in the southern United States. The noodler places their hand inside a discovered catfish hole in order to catch the fish.`,
				keywords	: `noodling`
			},
			{
				title 		: `Feng Shui Decorating`,
				description : `Anyone who has ever decorated home or office has taken part in interior design. It's a popular topic for many home and garden entertainment television shows. It is a popular hobby.`,
				keywords	: `feng shui`
			},
			{
				title 		: `Crabbing`,
				description : `The simplest way to catch crabs is with a dip net. Another easy method is to drop a fishing line with bait at the end. Simply wait for a tug then pull the crab in, catching it in a net.`,
				keywords	: `crabbing`
			},
			{
				title 		: `Boxing`,
				description : `During boxing workouts all anxiety, stress, fatigue and depression disappear and you start filling energy and strength again. Boxing training helps raising self-esteem and competencies.`,
				keywords	: `boxing`
			},
			{
				title 		: `Dog Walking`,
				description : `For those who like dogs, dog walking is an Income Hobby you can do to earn some extra cash and it's a great way to stay in shape. Some dog walkers work for a dog walking service, while others get their own clients.`,
				keywords	: `dog walking`
			},
			{
				title 		: `Organize a Neighborhood Clean-Up`,
				description : `A community cleanup brings volunteers together to clean, repair, and improve public spaces or other areas that have been neglected, vandalized, or misused.`,
				keywords	: `community cleanup`
			},
			{
				title 		: `Shell Fishing`,
				description : `Shellfish is a colloquial and fisheries term for exoskeleton-bearing aquatic invertebrates used as food, including various species of molluscs, crustaceans, and echinoderms.`,
				keywords	: `shellfish`
			},
			{
				title 		: `Fossil Hunting`,
				description : `Fossil collecting is the collection of fossils for scientific study, hobby, or profit. Fossil collecting, as practiced by amateurs, is the predecessor of modern paleontology and many still collect fossils and study fossils as amateurs.`,
				keywords	: `fossil hunting`
			},
			{
				title 		: `Foraging`,
				description : `Foraging is a hobby that involves searching for and eating plants, herbs and fruit. People have been foraging since the dawn of time and it's time for you to dip your hand into the hedgerows, trees and bushes to see what yummy treats you can discover.`,
				keywords	: `foraging`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.ForMen,
			name 			: `For Men`,
			icon 			: {
				style 		: 'solid',
				name 		: `person`
			}
		},
		hobbies 	: [
			{
				title		: `Travel Hacking`,
				description : `Travel hacking involves working within the existing rules set up by airlines, credit cards, and hotels, and using them to your advantage to earn free travel including flights, lodging, and other upgrades.`,
				keywords	: `travel hacking`
			},
			{
				title		: `Origami`,
				description : `Origami is the art of folding paper. And it can be really impressive with practice. All you need to become an origami master is paper, and time.`,
				keywords	: `origami`
			},
			{
				title		: `Martial Arts`,
				description : `There is a reason people take up martial arts for life when other hobbies fizzle out, and that is because martial arts is the gift that keeps on giving. Also, it can bring so much extra value to a person's life.`,
				keywords	: `martial arts`
			},
			{
				title		: `Working Out`,
				description : `A period of physical exercise that you do in order to improve your fitness, ability, or performance The team had a good workout at practice today. Workout includes running on the treadmill and lifting weights.`,
				keywords	: `working out`
			},
			{
				title		: `Practicing Survival Skills`,
				description : `Survival skills are techniques that a person may use in order to sustain life in any type of natural environment or built environment. These techniques are meant to provide basic necessities for human life which include water, food, and shelter.`,
				keywords	: `survival skills`
			},
			{
				title		: `Running`,
				description : `Running is a hobby, and in fact, it's one of the most versatile, beneficial hobbies you could have. Running is not only exercise, but it provides a way to relieve stress and improve your mood.`,
				keywords	: `running`
			},
			{
				title		: `Metal Working`,
				description : `Metalworking is the process of shaping and reshaping metals to create useful objects, parts, assemblies, and large scale structures.`,
				keywords	: `metalworking`
			},
			{
				title		: `Hookah Smoking`,
				description : `Hookah, or nargila, smoking is an art. Very popular in the Middle Eastern countries, hookah smoking is rapidly becoming common in the rest of the world.`,
				keywords	: `hookah`
			},
			{
				title		: `Caving`,
				description : `Caving - also known as spelunking in the United States and Canada - is the recreational pastime of exploring wild cave systems. In contrast, speleology is the scientific study of caves and the cave environment.`,
				keywords	: `caving`
			},
			{
				title		: `Weight Lifting`,
				description : `Overall, weightlifting is an excellent hobby to pick as it has so many benefits such as being able to keep you in shape, reduce your stress levels, and can be extremely fun.`,
				keywords	: `weight lifting`
			},
			{
				title		: `Jogging / Training For Marathon`,
				description : `Jogging is a form of trotting or running at a slow or leisurely pace. The main intention is to increase physical fitness with less stress on the body than from faster running but more than walking.`,
				keywords	: `marathon`
			},
			{
				title		: `Spearfishing`,
				description : `Spearfishing is one of the greatest ways to get out there and fish. Not only is it fun but it's affordable and most definitely sustainable. But don't be fooled, it is not easy.`,
				keywords	: `spearfishing`
			},
			{
				title		: `Car Racing`,
				description : `If speed is the medicine, then auto racing is the perfect hobby. Many think of auto racing as just getting behind the wheel of a fast car and going around laps, racing your opponents until that chequered flag is waved and someone ends up winning.`,
				keywords	: `car racing`
			},
			{
				title		: `Offroading`,
				description : `Offroading is the activity of driving or riding a vehicle on unsurfaced roads or tracks, made of materials such as sand, gravel, riverbeds, mud, snow, rocks, and other natural terrain.`,
				keywords	: `offroad`
			},
			{
				title		: `Shooting`,
				description : `So guns are really no different than any other hobby, they're just a means to release some stress and do something to enjoy. And added benefit is there's a small chance it could save your life one day, or at the least put some food on the table.`,
				keywords	: `shooting`
			},
			{
				title		: `Fencing`,
				description : `Fencing is a very easy sport to start at any age. It is fun, exciting and athletic. In foil fencing, touches can only be scored using the tip of the blade.`,
				keywords	: `fencing`
			},
			{
				title		: `Bouldering`,
				description : `Bouldering is a form of free climbing that is performed on small rock formations or artificial rock walls without the use of ropes or harnesses.`,
				keywords	: `bouldering`
			},
			{
				title		: `Hunting`,
				description : `Hunting as a hobby can be one of the most lucrative hobbies. Even a moderately successful hunter will easily pay for his/her hobby. Hunting is very challenging and rewarding on many different levels.`,
				keywords	: `hunting`
			},
			{
				title		: `Reviewing Gadgets`,
				description : `A gadget review consists of reviewing the technical accuracy and completeness of an article and correcting it if necessary. There are more gadgets reviews out there than you can count.`,
				keywords	: `gadget review`
			},
			{
				title		: `Woodworking`,
				description : `Woodworking is the skill of making items from wood, and includes cabinet making, wood carving, joinery, carpentry, and woodturning.`,
				keywords	: `woodworking`
			},
			{
				title		: `Building Electronics`,
				description : `Whether it is for the thrill of building equipment, repairing gadgets or saving a bit of money, hobby electronics is very rewarding. It requires a bit of learning in the beginning.`,
				keywords	: `building electronics`
			},
			{
				title		: `Archery`,
				description : `Coming from its historically rich background, archery is now considered as a sport, practice, and skill of shooting arrows using a bow. Aside from being a great hobby, archery can provide a lot of benefits.`,
				keywords	: `archery`
			},
			{
				title		: `Rock Climbing`,
				description : `Rock climbing is a sport in which participants climb up, down or across natural rock formations or artificial rock walls. The goal is to reach the summit of a formation or the endpoint of a usually pre-defined route without falling.`,
				keywords	: `rock climbing`
			},
			{
				title		: `Fishing`,
				description : `Fishing is the activity of trying to catch fish. Fish are often caught in the wild but may also be caught from stocked bodies of water.`,
				keywords	: `fishing`
			},
			{
				title		: `Flying`,
				description : `Hobby flying is also known as recreational flying or fun flying. Hobby flying includes Aero sports and Light Aircraft flying. Flying Microlight needs license known as Pilot License Microlight.`,
				keywords	: `flying`
			},
			{
				title		: `Shooting / Marksmanship`,
				description : `A marksman is someone who is excellent at shooting a gun. A skilled marksman hits the bull's eye every time.`,
				keywords	: `marksmanship`
			},
			{
				title		: `Hiking`,
				description : `Hiking is a long, vigorous walk, usually on trails or footpaths in the countryside. Walking for pleasure developed in Europe during the eighteenth century.`,
				keywords	: `hiking`
			},
			{
				title		: `Airplane Combat`,
				description : `A dogfight, or dog fight, is an aerial battle between fighter aircraft conducted at close range. Dogfighting first occurred in Mexico in 1913, shortly after the invention of the airplane.`,
				keywords	: `dogfight`
			},
			{
				title		: `Base Jumping`,
				description : `BASE jumping is the recreational sport of jumping from fixed objects, using a parachute to descend safely to the ground.`,
				keywords	: `base jumping`
			},
			{
				title		: `Beer Tasting`,
				description : `Wine, as well as beer tasting, has become a very famous hobby. It is similar to the one who loves whiskey. People who like wine and beer will learn, over time and tasting what to expect from different kinds of beer as well as wine.`,
				keywords	: `beer tasting`
			},
			{
				title		: `Barbecuing`,
				description : `Grilling can technically be defined as a method of cooking food directly on the heat that can either be meat, seafood, vegetables, etc. it enhances the flavor of food and make it more delicious than does the normal order of cooking. Grilling can even become a lifestyle.`,
				keywords	: `barbecuing`
			},
			{
				title		: `Racquetball`,
				description : `Racquetball is a racquet sport played with a hollow rubber ball on an indoor or outdoor court. Joseph Sobek invented the modern sport of racquetball in 1950, adding a stringed racquet to paddleball in order to increase velocity and control.`,
				keywords	: `racquetball`
			},
			{
				title		: `Smoking Meat`,
				description : `Smoking meat has not only become a passionate hobby for many but is also the theme of thousands of successful restaurants across the country. Who doesn't love a great meal of barbequed ribs and chicken!`,
				keywords	: `smoking meat`
			},
			{
				title		: `Ground Hopping`,
				description : `Groundhopping is a hobby that involves attending matches at as many different stadiums or grounds as possible. Participants are known as groundhoppers, hoppers or travellers.`,
				keywords	: `groundhopping`
			},
			{
				title		: `Chainsaw Carving`,
				description : `Chainsaw carving is a form of woodworking by means of a cutting tool in one hand or a chisel by two hands or with one hand on a chisel and one hand on a mallet, resulting in a wooden figure or figurine, or in the sculptural ornamentation of a wooden object.`,
				keywords	: `chainsaw carving`
			},
			{
				title		: `Allotment`,
				description : `An allotment garden, often called simply an allotment, or in North America, a community garden, is a plot of land made available for individual, non-commercial gardening or growing food plants.`,
				keywords	: `allotment`
			},
			{
				title		: `Anti-Gravity Cocooning`,
				description : `Anti-gravity cocooning is similar to anti-gravity yoga, but with more relaxation time. ... After about 20 or 30 minutes, you'll assume a cocoon position—which is one you're comfortable in to maximize relaxation.`,
				keywords	: `anti-gravity cocooning`
			},
			{
				title		: `Retro Gaming`,
				description : `Retrogaming, also known as classic gaming and old school gaming, is the playing and/or collection of older (or older versions of) personal computers, consoles, and/or video games (generally arcade), in contemporary times.`,
				keywords	: `retro gaming`
			},
			{
				title		: `Cliff Diving`,
				description : `Cliff diving is an adrenaline-charged, exhilarating form of extreme sports. The thrill and sheer joy of diving with adrenaline rushing through your body is attracting people to take it up as a hobby.`,
				keywords	: `cliff diving`
			},
			{
				title		: `Amateur Geology`,
				description : `Amateur geology or rock collecting (also referred to as rockhounding in the United States and Canada) is the non-professional study and hobby of collecting rocks and minerals or fossil specimens from the natural environment.`,
				keywords	: `amateur geology`
			},
			{
				title		: `Audiophile`,
				description : `An audiophile is a person who is enthusiastic about high-fidelity sound reproduction. An audiophile seeks to reproduce the sound of a live musical performance, typically in a room with good acoustics.`,
				keywords	: `audiophile`
			},
			{
				title		: `Beat Box`,
				description : `Beatboxing is a form of vocal percussion primarily involving the art of mimicking drum machines, using one's mouth, lips, tongue, and voice.`,
				keywords	: `beatboxing`
			},
			{
				title		: `Break Dancing`,
				description : `Breakdancing, also called breaking or b-boying/b-girling, is an athletic style of street dance originating from the African American and Puerto Rican communities in the United States.`,
				keywords	: `break dancing`
			},
			{
				title		: `Tomahawk / Hatchet Throwing`,
				description : `Axe throwing is regarded as a recreational activity that invites people who love extreme sports and wish to release rage by hurling their axes on a wooden log.`,
				keywords	: `axe throwing`
			},
			{
				title		: `Ice Fishing`,
				description : `Ice fishing is the practice of catching fish with lines and fish hooks or spears through an opening in the ice on a frozen body of water.`,
				keywords	: `ice fishing`
			},
			{
				title		: `Kitesurfing`,
				description : `Kiteboarding or kitesurfing is an extreme sport where the kiter uses the wind power with a large power kite to be pulled on a water, land or snow surface. It combines aspects of paragliding, surfing, windsurfing, skateboarding, snowboarding and wakeboarding.`,
				keywords	: `kitesurfing`
			},
			{
				title		: `Motocross`,
				description : `Motocross is a form of off-road motorcycle racing held on enclosed off-road circuits. The sport evolved from motorcycle trials competitions held in the United Kingdom.`,
				keywords	: `motocross`
			},
			{
				title		: `Paragliding`,
				description : `Paragliding is the recreational and competitive adventure sport of flying paragliders: lightweight, free-flying, foot-launched glider aircraft with no rigid primary structure.`,
				keywords	: `paragliding`
			},
			{
				title 		: `Skeet Shooting`,
				description : `Skeet shooting is a recreational and competitive activity where participants, using shotguns, attempt to break clay targets mechanically flung into the air from two fixed stations at high speed from a variety of angles.`,
				keywords	: `skeet shooting`
			},
			{
				title 		: `Drag Boat Racing`,
				description : `Drag boat racing is a form of drag racing which takes place on water rather than land. As with land-based drag racing, competitors race their vehicles for the lowest elapsed time (low ET) over a straight race course of a defined length.`,
				keywords	: `drag boat racing`
			},
			{
				title 		: `Whittling`,
				description : `Whittling may refer either to the art of carving shapes out of raw wood using a knife or a time-occupying, non-artistic process of repeatedly shaving slivers from a piece of wood.`,
				keywords	: `whittling`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.ForCouples,
			name 			: `For Couples`,
			icon 			: {
				style 		: 'solid',
				name 		: `circle-heart`
			}
		},
		hobbies 	: [
			{
				title 		: `Storm Chasing`,
				description : `Some meteorologists started chasing storms in the name of science many decades ago but storm chasing as a hobby and tourism industry is still quite young. The whole idea about storm chasing is to find violent storms and experience the beauty and power they possess.`,
				keywords	: `storm chasing`
			},
			{
				title 		: `Orienteering Sports`,
				description : `Orienteering is a group of sports that require navigational skills using a map and compass to navigate from point to point in diverse and usually unfamiliar terrain whilst moving at speed.`,
				keywords	: `orienteering sports`
			},
			{
				title 		: `Jet Sprint Boat Racing`,
				description : `Jetsprint or sprint boat racing is a form of motorboat racing in which jetboats, with a crew of two, race individually against the clock through a twisting series of channels in less than a metre of water.`,
				keywords	: `jetsprint`
			},
			{
				title 		: `Yoga`,
				description : `Yoga is a group of physical, mental, and spiritual practices or disciplines which originated in ancient India and aim to control and still the mind.`,
				keywords	: `yoga`
			},
			{
				title 		: `Snorkeling`,
				description : `Snorkeling is the practice of swimming on or through a body of water while equipped with a diving mask, a shaped breathing tube called a snorkel, and usually swimfins.`,
				keywords	: `snorkeling`
			},
			{
				title 		: `Message`,
				description : `Message is the manipulation of the body's soft tissues. Message techniques are commonly applied with hands, fingers, elbows, knees, forearms, feet, or a device.`,
				keywords	: `message`
			},
			{
				title 		: `Squash`,
				description : `Squash is a racket and ball sport played by two players in a four-walled court with a small, hollow rubber ball. The players alternate in striking the ball.`,
				keywords	: `squash`
			},
			{
				title 		: `Wine / Cheese Tasting`,
				description : `Wine tasting is the sensory examination and evaluation of wine. While the practice of wine tasting is as ancient as its production, a more formalized methodology has slowly become established from the 14th century onward.`,
				keywords	: `cheese tasting`
			},
			{
				title 		: `Ballroom Dancing`,
				description : `Ballroom dance is a set of partner dances, which are enjoyed both socially and competitively around the world, mostly because of its performance and entertainment aspects. Ballroom dancing is also widely enjoyed on stage, film, and television.`,
				keywords	: `ballroom Dancing`
			},
			{
				title 		: `Volunteering`,
				description : `What to have a hobby that also contributes and gives back? Volunteering is the way to go. So many organizations are looking for great help - there are nearly limitless ways that you can spend your time giving back.`,
				keywords	: `volunteering`
			},
			{
				title 		: `Sailing`,
				description : `ailing employs the wind—acting on sails, wingsails or kites—to propel a craft on the surface of the water, on ice or on land over a chosen course, which is often part of a larger plan of navigation.`,
				keywords	: `sailing`
			},
			{
				title 		: `Tennis`,
				description : `Tennis is a racket sport that can be played individually against a single opponent or between two teams of two players each. Each player uses a tennis racket that is strung with cord to strike.`,
				keywords	: `tennis`
			},
			{
				title 		: `Star Gazing`,
				description : `Amateur astronomy is a hobby where participants enjoy observing or imaging celestial objects in the sky using the unaided eye, binoculars, or telescopes. ... Most amateurs are hobbyists, while others have a high degree of experience in astronomy.`,
				keywords	: `star gazing`
			},
			{
				title 		: `Canoeing`,
				description : `Both canoeing and kayaking involve paddling a small craft through water. They are low-impact activities that can improve your aerobic fitness, strength and flexibility. Canoeing and kayaking can be done as a hobby, a competitive sport or as a fun activity on holidays.`,
				keywords	: `canoeing`
			},
			{
				title 		: `Bowling`,
				description : `Bowling is a target sport and recreational activity in which a player rolls a ball toward pins or another target. The term bowling usually refers to pin bowling, though in the United Kingdom.`,
				keywords	: `bowling`
			},
			{
				title 		: `Learning A Foreign Language`,
				description : `Another fun hobby can be learning another language. Some people love languages and love to learn new ways how to express themselves in different societies and countries.`,
				keywords	: `language learning`
			},
			{
				title 		: `Recipe Creation`,
				description : `There are plenty of reasons to take up cooking as a hobby. Aside from health benefits, cooking is also a great way to explore other cultures. Trying new foods from different cultures can lead you to find new favorite dishes.`,
				keywords	: `recipe creation`
			},
			{
				title 		: `People Watching`,
				description : `People-watching or crowd watching is the act of observing people and their interactions as a subconscious doing. For some people, it is considered a hobby, but for many others, it is a subconscious activity they partake in every day.`,
				keywords	: `crowd watching`
			},
			{
				title 		: `Picnicking`,
				description : `A picnic is a meal taken outdoors as part of an excursion, especially in scenic surroundings, such as a park, lakeside, or other place affording an interesting view.`,
				keywords	: `picnicking`
			},
			{
				title 		: `Acroyoga`,
				description : `Acroyoga (also written Acro-Yoga or Acro Yoga) is a physical practice that combines yoga and acrobatics. Acroyoga includes many types of (mostly recreational) partner and group acrobatics in which at least someone is lifted.`,
				keywords	: `acroyoga`
			},
			{
				title 		: `Dancing`,
				description : `Dance is a performing art form consisting of sequences of movement, either improvised or purposefully selected. This movement has aesthetic and often symbolic value.`,
				keywords	: `dancing`
			},
			{
				title 		: `Salsa Dancing`,
				description : `Salsa is a Latin dance associated with the music genre of the same name which was first popularized in the United States in the 1960s in New York City. Salsa is an amalgamation of Cuban dances.`,
				keywords	: `salsa dancing`
			},
			{
				title 		: `Pottery`,
				description : `Pottery is the process and the products of forming vessels and other objects with clay and other ceramic materials, which are fired at high temperatures to give them a hard and durable form.`,
				keywords	: `pottery`
			},
			{
				title 		: `Badminton`,
				description : `Badminton is a racquet sport played using racquets to hit a shuttlecock across a net. Although it may be played with larger teams, the most common forms of the game are "singles" and "doubles".`,
				keywords	: `badminton`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.ForFamily,
			name 			: `For Family`,
			icon 			: {
				style 		: 'regular',
				name 		: `futbol`
			}
		},
		hobbies 	: [
			{
				title 		: `Renovating`,
				description : `People interested in DIY projects often find home improvement to be a satisfying hobby. Knowing how to remodel a room or complete repairs around the home can increase the market value of a home.`,
				keywords	: `renovating`
			},
			{
				title 		: `Hosting Dinner Parties`,
				description : `A dinner party is a social event where a small group of people are invited to have dinner and spend the evening at someone's house.`,
				keywords	: `dinner party`
			},
			{
				title 		: `Road Trips`,
				description : `A road trip, sometimes spelled roadtrip, is a long-distance journey on the road. Typically, road trips are long distances traveled by automobile.`,
				keywords	: `road trip`
			},
			{
				title 		: `Cosplaying`,
				description : `Cosplay, a portmanteau of "costume play", is an activity and performance art in which participants called cosplayers wear costumes and fashion accessories to represent a specific character.`,
				keywords	: `cosplaying`
			},
			{
				title 		: `Cooking`,
				description : `There are plenty of reasons to take up cooking as a hobby. Aside from health benefits, cooking is also a great way to explore other cultures. Trying new foods from different cultures can lead you to find new favorite dishes.`,
				keywords	: `cooking`
			},
			{
				title 		: `Drawing`,
				description : `Drawing is another paper-based hobby that is totally free. All you need is something to write with - pencil, pen, crayon, chalk, anything! Beyond that, it's just your imagination.`,
				keywords	: `drawing`
			},
			{
				title 		: `Flying Model Planes`,
				description : `A model aircraft is a small unmanned aircraft and may be a replica of an existing or imaginary aircraft. Model aircraft are divided into two basic groups: flying and non-flying.`,
				keywords	: `model planes`
			},
			{
				title 		: `Model Ship Building`,
				description : `Model ship building is an interesting and challenging hobby enjoyed by many. Combining elements of history, technology, and craftsmanship, model ship building offers a unique finished product that the builder can showcase with pride.`,
				keywords	: `model ship`
			},
			{
				title 		: `Collecting Seashells`,
				description : `Shell collecting, practice of finding and usually identifying the shells of mollusks, a popular avocation, or hobby, in many parts of the world. These shells, because of their bright colours, rich variety of shapes and designs, and abundance along seashores, have long been used for ornaments, tools, and coins.`,
				keywords	: `shell collecting`
			},
			{
				title 		: `Beach / Sand Building`,
				description : `Sand castles are typically made by children for fun, but there are also sand-sculpture contests for adults that involve large, complex constructions.`,
				keywords	: `sand castles`
			},
			{
				title 		: `Nature Walk`,
				description : `An educational trail, nature trail or nature walk is a specially developed hiking trail or footpath that runs through the countryside, along which there are marked stations or stops next to natural interests.`,
				keywords	: `walking`
			},
			{
				title 		: `Zoo Visits`,
				description : `Zoo is a fun place to be. You will be educated and entertained at the same time. Zoos give you the opportunity to re-connect with your inner child.`,
				keywords	: `zoo`
			},
			{
				title 		: `Collecting Stickers`,
				description : `If you're starting a sticker collection, look for stickers online and in local stores, as well as at local craft shows. Once your collection begins to grow, organize your stickers in binders, bins, or photo albums by theme or style.`,
				keywords	: `collecting stickers`
			},
			{
				title 		: `Collecting Leaves`,
				description : `Collecting leaves or leaf rubbings and prints can be an enjoyable hobby. You can find plants with interesting leaves in fields, forests, and gardens and even along city streets.`,
				keywords	: `collecting leaves`
			},
			{
				title 		: `Puppetry`,
				description : `Puppetry is a form of theatre or performance that involves the manipulation of puppets - inanimate objects, often resembling some type of human or animal figure, that are animated or manipulated by a human called a puppeteer.`,
				keywords	: `puppetry`
			},
			{
				title 		: `Playing T-Ball`,
				description : `Tee-ball is a team sport based on a simplified form of baseball or softball. It is intended as an introduction for children aged 4 to 6 to develop ball-game skills and have fun.`,
				keywords	: `t-ball`
			},
			{
				title 		: `Mini Golf`,
				description : `The hobby of mini golf has skyrocketed in popularity in recent years. People are realizing how this activity is a fun and affordable outing for the whole family.`,
				keywords	: `mini golf`
			},
			{
				title 		: `Playing Soccer`,
				description : `Association football, more commonly known as simply football or soccer, is a team sport played with a spherical ball between two teams of 11 players. It is played by approximately 250 million players.`,
				keywords	: `soccer`
			},
			{
				title 		: `Finger Painting`,
				description : `Finger painting is a great way for children to explore, learn and develop through sensory play. When children can feel the cool, squishy texture of the paint and experiment with colour and patterns.`,
				keywords	: `finger painting`
			},
			{
				title 		: `Collecting Stamps`,
				description : `Stamp collecting is generally accepted as one of the areas that make up the wider subject of philately, which is the study of stamps.`,
				keywords	: `stamp collecting`
			},
			{
				title 		: `Coloring`,
				description : `Coloring is a great hobby. It's the ideal way to relax after a hard day and perfect for giving your creativity a boost. Coloring can provide an easy time-out.`,
				keywords	: `coloring`
			},
			{
				title 		: `Lego Building / Assembling`,
				description : `Lego's consists of colorful interlocking plastic bricks, an array of gears, mini characters and various other parts. LEGO bricks can be assembled to construct vehicles, buildings, people, bridges, and even working robots (Note: do not use LEGO as a keyword).`,
				keywords	: `lego building`
			},
			{
				title 		: `Feeding Wild Birds`,
				description : `Many Americans enjoy spending time with nature, and one popular activity is feeding wild birds. As many as 53 million Americans feed birds as a hobby each year.`,
				keywords	: `feeding birds`
			},
			{
				title 		: `Insect Interest`,
				description : `Entomology is the study of insects, which can informally include mini-beasts that aren't scientifically classified as insects. Professional and amateur entomologists sometimes maintain bug collections.`,
				keywords	: `entomology`
			},
			{
				title 		: `Crocheting`,
				description : `Crochet is a process of creating textiles by using a crochet hook to interlock loops of yarn, thread, or strands of other materials.`,
				keywords	: `crocheting`
			},
			{
				title 		: `Flower Pressing`,
				description : `Oshibana is the art of using pressed flowers and other botanical materials to create an entire picture from these natural elements. Such pressed flower art consists of drying flower petals and leaves in a flower press to flatten and exclude light and moisture.`,
				keywords	: `flower pressing`
			},
			{
				title 		: `Trekking`,
				description : `It is an adventure sport. Trekking - or long-distance hiking - consists of walking for several days or several weeks and being entirely or partially self-sufficient.`,
				keywords	: `trekking`
			},
			{
				title 		: `Knitting`,
				description : `Knitting is a method by which yarn is manipulated to create a textile or fabric. It is one of the least expensive and most rewarding skills. Everyone can learn it, enjoy it and even earn from it.`,
				keywords	: `knitting`
			},
			{
				title 		: `Ice Skating`,
				description : `Ice skating is the self-propulsion and gliding of a person across an ice surface, using metal-bladed ice skates. People skate for various reasons, including recreation, exercise, competitive sports, and commuting.`,
				keywords	: `skating`
			},
			{
				title 		: `Speed Cubing (Rubix Cube)`,
				description : `The Rubik's Cube is a 3-D combination puzzle. Playing With A Rubik's Cube Has A Lot Of Advantage. Unlike other hobbies, Rubik's cube has little to no disadvantage (Note: du not use "Rubix Cube" as a keyword).`,
				keywords	: `speed cubing`
			},
			{
				title 		: `Creating Family Trees`,
				description : `Genealogy is a versatile hobby. One's family history may be recorded with a simple pen and paper, or it can involve expensive computer equipment.`,
				keywords	: `family tree`
			},
			{
				title 		: `Story-Writing`,
				description : `Turning writing into a hobby takes determination. It may not seem so, but making time to write, finding things to write about and then remaining dedicated to seeing the entire piece through to its endpoint requires planning and self-discipline.`,
				keywords	: `story writing`
			},
			{
				title 		: `Collecting Baseball Cards`,
				description : `Collecting cards can spark or boost interest in baseball. It makes baseball fun! There's no feeling like opening a pack of cards and getting one of your favorite players!`,
				keywords	: `collecting cards`
			},
			{
				title 		: `Pencil Sketching`,
				description : `Rest and relaxation is one of the main advantages of sketching, as a hobby. There are no rules and no one telling you what to do, you can just draw whatever you want and have fun while doing it.`,
				keywords	: `pencil sketching`
			},
			{
				title 		: `Jewellery Making`,
				description : `Jewelry design is a hobby that opens up a lot of scope to show creativity. This hobby can easily turn into a lucrative home business or career with a prominent name in the industry.`,
				keywords	: `jewellery making`
			},
			{
				title		: `Doing Science Experiments`,
				description : `For kids of all ages, the benefits are enormous. Doing science projects helps develop a child's resourcefulness, particularly their skills at goal-setting, planning, and problem-solving.`,
				keywords	: `science project`
			},
			{
				title 		: `Juggling`,
				description : `Juggling is a physical skill, performed by a juggler, involving the manipulation of objects for recreation, entertainment, art or sport. The most recognizable form of juggling is toss juggling.`,
				keywords	: `juggling`
			},
			{
				title 		: `Kite Flying`,
				description : `A kite is a tethered heavier-than-air or lighter-than-air craft with wing surfaces that react against the air to create lift and drag forces. A kite consists of wings, tethers and anchors.`,
				keywords	: `kite flying`
			},
			{
				title 		: `Collecting Marbles`,
				description : `The nostalgic toy can take adults back in time to childhood games. Their distinctive and colorful materials and styles also can help collectors of all ages explore the glittering world of contemporary glass art.`,
				keywords	: `collecting marbles`
			},
			{
				title 		: `Roller Blading`,
				description : `Inline skating is a multi-disciplinary sport and can refer to a number of activities practiced using inline skates. Inline skates typically have two to five polyurethane wheels depending on the style of practice.`,
				keywords	: `roller blading`
			},
			{
				title 		: `Collage Making`,
				description : `Collage is a simple craft activity that involves pasting items like leaves or photographs onto a sheet of paper. Making a collage helps your child build fine motor skills.`,
				keywords	: `collage making`
			},
			{
				title 		: `Paper Mache`,
				description : `Papier-mâché is a composite material consisting of paper pieces or pulp, sometimes reinforced with textiles, bound with glue. The children have been using old newspaper, left over office paper and paper cut offs to create their masterpieces.`,
				keywords	: `paper mache`
			},
			{
				title 		: `Making Bookmarks`,
				description : `Bookmarks help you keep track of your progress and quickly return to where the previous reading session ended. Fun bookmarks for kids encourage them to care for their books and maintain them well.`,
				keywords	: `bookmarks`
			},
			{
				title 		: `Skateboarding`,
				description : `Skateboarding is an action sport originating in the United States that involves riding and performing tricks using a skateboard, as well as a recreational activity. It is mostly popular in the United States but also in Europe.`,
				keywords	: `skateboarding`
			},
			{
				title 		: `Acrobatics`,
				description : `Acrobatics is the performance of human feats of balance, agility, and motor coordination. Acrobatic skills are used in performing arts, sporting events, and martial arts.`,
				keywords	: `acrobatics`
			},
			{
				title 		: `Jump Roping`,
				description : `Jump roping is definitely a hobby as it has all the characteristics of one which is to perform an activity for pleasure, but at the same time, it's also an incredibly easy way to get in shape.`,
				keywords	: `jump roping`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Indoor,
			name 			: `Indoor`,
			icon 			: {
				style 		: 'solid',
				name 		: `mug-saucer`
			}
		},
		hobbies 	: [
			{
				title 		: `Color Guard`,
				description : `There is a bit of controversy as to whether color guard is a sport or an art or just some silly hobby that people take on. If you do not know already, color guard is a physical activity that incorporates equipment like flags, rifles and sabers into lyrical and jazz dancing.`,
				keywords	: `color guard`
			},
			{
				title 		: `Cheerleading`,
				description : `Cheerleading is FUN. Kids just wanna have fun. They work hard, they push themselves, they learn new skills, but at the heart of it all, cheer is about celebrating life and having fun together.`,
				keywords	: `cheerleading`
			},
			{
				title 		: `Baton Twirling`,
				description : `Baton twirling involves using the body to spin a metal rod in a coordinated routine. It is similar to rhythmic gymnastics or color guard.`,
				keywords	: `baton twirling`
			},
			{
				title 		: `Scouting`,
				description : `Scouting is a fun hobby that gives you many kinds of useful skills. It offers plenty of great activities such as nature trips, camps and playing and learning new things together.`,
				keywords	: `scouting`
			},
			{
				title 		: `RC Model Racing`,
				description : `The world of RC is a family-oriented hobby that allows people to come together and have fun driving and racing their high-performance radio controlled vehicles. There are many types, shapes and sizes of radio controlled vehicles.`,
				keywords	: `rc racing`
			},
			{
				title 		: `Stone Skipping`,
				description : `Stone skipping and stone skimming are considered related but distinct activities: both refer to the art of throwing a flat stone across the water in such a way that it bounces off the surface.`,
				keywords	: `stone skipping`
			},
			{
				title 		: `Gymnastics`,
				description : `Gymnastics is a sport that includes physical exercises requiring balance, strength, flexibility, agility, coordination, dedication and endurance.`,
				keywords	: `gymnastics`
			},
			{
				title 		: `Book Clubs`,
				description : `An opportunity for socialising. Attending a book group immediately turns an independent hobby into a much more social activity. Many book group discussions act as a catalyst for a conversation about another topic or moral dilemma.`,
				keywords	: `book club`
			},
			{
				title 		: `Coffee Roasting`,
				description : `Roasting coffee transforms the chemical and physical properties of green coffee beans into roasted coffee products. The roasting process is what produces the characteristic flavor of coffee by causing the green coffee beans to change in taste.`,
				keywords	: `coffee roasting`
			},
			{
				title 		: `Airbrushing`,
				description : `An airbrush is a small, air-operated tool that atomizes and sprays various media, most often paint but also ink and dye, and foundation. Spray painting developed from the airbrush and is considered to employ a type of airbrush.`,
				keywords	: `airbrush`
			},
			{
				title 		: `Gunsmithing`,
				description : `A gunsmith is a person who repairs, modifies, designs, or builds guns. The occupation differs from an armorer, who usually replaces only worn parts in standard firearms.`,
				keywords	: `gunsmith`
			},
			{
				title 		: `Pinochle`,
				description : `Pinochle, also called pinocle or penuchle, is a trick-taking, Ace-Ten card game typically for two to four players and played with a 48-card deck. It is derived from the card game bezique.`,
				keywords	: `pinochle`
			},
			{
				title 		: `Calligraphy`,
				description : `Calligraphy is a visual art related to writing. It is the design and execution of lettering with a pen, ink brush, or other writing instrument. A contemporary calligraphic practice can be defined as "the art of giving form to signs in an expressive, harmonious, and skillful manner".`,
				keywords	: `calligraphy`
			},
			{
				title 		: `Chocolate Making`,
				description : `Making chocolate at home is a very fulfilling hobby, as you can get as into researching it as much or as little as you want. There's a lot of science behind how each process works, from the pod to the bar.`,
				keywords	: `chocolate making`
			},
			{
				title 		: `Ceramics`,
				description : `Pottery is the process and the products of forming vessels and other objects with clay and other ceramic materials, which are fired at high temperatures to give them a hard, durable form. Major types include earthenware, stoneware and porcelain.`,
				keywords	: `ceramics`
			},
			{
				title 		: `Scrapbooking`,
				description : `Scrapbooking is a method of preserving, presenting and arranging personal and family history in the form of a book, box or card. Typical memorabilia include photographs, printed media, and artwork.`,
				keywords	: `scrapbooking`
			},
			{
				title 		: `Fishkeeping`,
				description : `Fishkeeping is a relatively an inexpensive hobby as compared to any other animal keeping. The price of fish is always lesser than the price of dogs, cats, birds, or any other pet animal.`,
				keywords	: `fishkeeping`
			},
			{
				title 		: `Soap Making`,
				description : `Soapmaking is a fun, simple and low cost hobby that is a great activity for the entire family. While many people choose to buy their soap from retailers and stores, making your own soap has a lot of advantages.`,
				keywords	: `soapmaking`
			},
			{
				title 		: `Knife Making`,
				description : `Knife making is the process of manufacturing a knife by any one or a combination of processes: stock removal, forging to shape, welded lamination or investment cast. Typical metals used come from the carbon steel, tool, or stainless steel families.`,
				keywords	: `knife making`
			},
			{
				title 		: `Dandyism`,
				description : `A dandy is a man who places particular importance upon physical appearance, refined language, and leisurely hobbies, pursued with the appearance of nonchalance, in his cult of the Self.`,
				keywords	: `dandy`
			},
			{
				title 		: `Collecting Model Trains`,
				description : `Model railroading can be a very social hobby. It's a great way to meet new people. There are clubs and associations that you can join. These clubs run the whole range.`,
				keywords	: `model trains`
			},
			{
				title 		: `War Gaming`,
				description : `Wargaming may be played for recreation, to train military officers in the art of strategic thinking, or to study the nature of potential conflicts. ... Civilian enthusiasts also played wargames for fun.`,
				keywords	: `wargaming`
			},
			{
				title 		: `Poker`,
				description : `Poker is a family of card games in which players wager over which hand is best according to that specific game's rules in ways similar to these rankings.`,
				keywords	: `poker`
			},
			{
				title 		: `Playing Darts`,
				description : `Darts is a great hobby and a past time activity that will not necessarily place any unwanted stress or demand on your body and mind. It is great for anybody who's looking to relax after a long day.`,
				keywords	: `darts`
			},
			{
				title 		: `Sculpting`,
				description : `Sculpting is an excellent hobby that can be cultivated without any special talents. The most unique aspect of sculpting is it allows to create three-dimensional objects. As one of the world's oldest art form, sculpting has been in existence for thousands of years.`,
				keywords	: `sculpting`
			},
			{
				title 		: `Lockpicking`,
				description : `Lock picking is a fantastic hobby, cheap to buy the things you need and learn. Being able to open locks also gives you a sense of power, it feels good to be able to look at a lock and know you can pick it open.`,
				keywords	: `lockpicking`
			},
			{
				title 		: `Watch Making`,
				description : `Watchmaking is a hobby that yields a lot of intellectual stimulation and intrinsic rewards. The reasons why you should build your own watch are numerous and meaningful due to its rich history and technological complexity.`,
				keywords	: `watchmaking`
			},
			{
				title 		: `Jam Making`,
				description : `For many people, jam making is as much a passion as it is a hobby. This is a great way to preserve seasonal fruit and enjoy it for the whole year, while some avid jam-makers simply enjoy gifting their decorated jars as thoughtful presents.`,
				keywords	: `jam making`
			},
			{
				title 		: `Floristry`,
				description : `Unlike many other hobbies, with flower arranging you don't need a lot of expensive equipment. Use flowers and foliage from your own garden, or you can often buy flowers at a good price at a market.`,
				keywords	: `floristry`
			},
			{
				title 		: `Ghost Hunting`,
				description : `Ghost hunting is the process of investigating locations that are reported to be haunted by ghosts. Typically, a ghost-hunting team will attempt to collect evidence supporting the existence of paranormal activity.`,
				keywords	: `ghost hunting`
			},
			{
				title 		: `3D Printing`,
				description : `3D printing can be a personally enriching hobby that will expand the limits of your creativity and inventiveness. But it's also a marketable and desirable skill.`,
				keywords	: `3d printing`
			},
			{
				title 		: `Macrame`,
				description : `It is more of a creative art of knotting in geometric patterns to create amazing home decorations, wall hangings, jewelry, plant holders etc. Today macramé has regained the immense popularity because of its amazing crafts and revival of interest from people.`,
				keywords	: `macramé`
			},
			{
				title 		: `Knapping`,
				description : `Knapping is the shaping of flint, chert, obsidian, or other conchoidal fracturing stone through the process of lithic reduction to manufacture stone tools, strikers for flintlock firearms, or to produce flat-faced stones for building or facing walls, and flushwork decoration.`,
				keywords	: `knapping`
			},
			{
				title 		: `Lacemaking`,
				description : `Bobbin lace is a lace textile made by braiding and twisting lengths of thread, which are wound on bobbins to manage them. Beautiful laces that you create gives a sense of achievement and pleasure beyond comparison.`,
				keywords	: `lacemaking`
			},
			{
				title 		: `Lapidary`,
				description : `Lapidary as a hobby attracts certain people who like to learn new hobbies. It is the practice of shaping stone, minerals, or gemstones into decorative items such as cabochons, engraved gems, and faceted designs.`,
				keywords	: `lapidary`
			},
			{
				title 		: `Book Restoration`,
				description : `Book restoration as a hobby could be great interest when you fall in love with books and reading. Some people say that restoration is a higher or more advanced level of a bibliophile.`,
				keywords	: `book restoration`
			},
			{
				title 		: `Podcasting`,
				description : `New podcasts are being created every day. A podcast is an episodic series of digital audio files that a user can download to a personal device to listen to at a time of their choosing.`,
				keywords	: `podcast`
			},
			{
				title 		: `Table Tennis`,
				description : `Table tennis, also known as ping-pong, is a sport in which two or four players hit a lightweight ball, also known as the ping-pong ball, back and forth across a table using small solid rackets.`,
				keywords	: `table tennis`
			},
			{
				title 		: `Reef Aquarium`,
				description : `A reef aquarium or reef tank is a marine aquarium that prominently displays live corals and other marine invertebrates as well as fish that play a role in maintaining the tropical coral reef environment.`,
				keywords	: `reef aquarium`
			},
			{
				title 		: `Bookbinding`,
				description : `Bookbinding is the process of physically assembling a book of codex format from an ordered stack of paper sheets that are folded together into sections called signatures or sometimes left as a stack of individual sheets.`,
				keywords	: `bookbinding`
			},
			{
				title 		: `Matchstick Modeling`,
				description : `Matchstick models are scale models made from matches as a hobby. Regular matches are not used, however, but a special modeling type which do not have the combustible heads, and can be bought from art and craft shops.`,
				keywords	: `matchstick model`
			},
			{
				title 		: `Inventing`,
				description : `When you invent as a hobby, it doesn't really matter to you if your invention would make money, you just love to tinker and dream of what it could be. The decision to invent as a career isn't an on-off switch decision.`,
				keywords	: `inventor`
			},
			{
				title 		: `Kitchen Chemistry`,
				description : `Amateur chemistry or home chemistry is the pursuit of chemistry as a private hobby. Amateur chemistry is usually done with whatever chemicals are available at disposal at the privacy of one's home.`,
				keywords	: `home chemistry`
			},
			{
				title 		: `Knotting`,
				description : `It's no surprise that learning to tie knots, from tying your shoes to essential camping and boating knots, promotes increased hand-eye coordination skills, and fine motor skills too.`,
				keywords	: `knotting`
			},
			{
				title 		: `Tarot Reading`,
				description : `Tarot reading also known as tarot card reading—is a form of divination in which psychics interpret tarot cards to give you insight into your future and guidance about the right path to take.`,
				keywords	: `tarot reading`
			},
			{
				title 		: `Sushi Making`,
				description : `Sushi making can be a really fun hobby and is surprisingly easy to make. Sushi is a kind of Japanese food consisting of cooked rice that has been vinegared and combined with other ingredients like seafood, vegetables and sometimes fruits.`,
				keywords	: `sushi making`
			},
			{
				title 		: `Scale Miniature Building`,
				description : `Miniature building is an excellent hobby for anyone who enjoys working with their hands. Almost every hand building technique is used to make a single miniature building: sewing, woodworking, stained glass, framing, wiring, plumbing, and more.`,
				keywords	: `miniature building`
			},
			{
				title 		: `Collecting Diecast Cars`,
				description : `Diecast models tend to demonstrate a higher level of detail than plastic counterparts, and also give them greater longevity - a major positive for avid collectors.`,
				keywords	: `diecast`
			},
			{
				title 		: `Building Ships In Bottles`,
				description : `For centuries, sailors created model ships, and the craft became more artistic as time went on. However, people didn't put these model ships into bottles until the mid-19th Century.`,
				keywords	: `model ship`
			},
			{
				title 		: `Poetry`,
				description : `Writing poetry can be a rewarding hobby, especially if you enjoy writing or are looking to express yourself through a different medium.`,
				keywords	: `poetry`
			},
			{
				title 		: `Glowsticking`,
				description : `Glowsticking is a form of dance where the performer uses glow sticks, or LED sticks to enhance their performance. Think of fire eating, ribbon dancing or poi but with glow sticks.`,
				keywords	: `glowsticking`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Your20s,
			name 			: `For Your 20's`,
			icon 			: {
				style 		: 'solid',
				name 		: `mobile`
			}
		},
		hobbies 	: [
			{
				title 		: `Tatting`,
				description : `Tatting is a technique for handcrafting a particularly durable lace from a series of knots and loops. Tatting can be used to make lace edging as well as doilies, collars, accessories such as earrings and necklaces, and other decorative pieces.`,
				keywords	: `tatting`
			},
			{
				title 		: `Storytelling`,
				description : `Story-telling is not a mere hobby, but can be a full-fledged career option - Aditi Dewra. When we talk about art, we mostly think of painters, dancers, singers or the writers, but forget an important life-art of has been forgotten story-telling.`,
				keywords	: `storytelling`
			},
			{
				title 		: `Embroidery`,
				description : `Embroidery is the craft of decorating fabric or other materials using a needle to apply thread or yarn. Embroidery may also incorporate other materials such as pearls, beads, quills, and sequins.`,
				keywords	: `embroidery`
			},
			{
				title 		: `Crossword Puzzles`,
				description : `A crossword is a word puzzle that usually takes the form of a square or a rectangular grid of white- and black-shaded squares. The game's goal is to fill the white squares with letters, forming words or phrases, by solving clues, which lead to the answers.`,
				keywords	: `crossword`
			},
			{
				title 		: `Urban Exploration`,
				description : `Urban Exploration as a hobby has been around for a while now. In essence, this hobby is about exploring the city around you to submerge in its history.`,
				keywords	: `urban exploration`
			},
			{
				title 		: `Tower Running`,
				description : `Tower running is a sport which involves running up tall man-made structures. Usually the races take place on the internal staircases of skyscrapers, but the term can cover any foot race which involves a course that ascends a man-made structure.`,
				keywords	: `tower running`
			},
			{
				title 		: `Camping`,
				description : `Camping is basically an act of leaving the luxuries and amenities of modern life for a few days and spending time outside in more primitive conditions. It is a thrilling outdoor hobby for children of all ages.`,
				keywords	: `camping`
			},
			{
				title 		: `Surfing`,
				description : `Surfing is a surface water sport in which an individual, a surfer, uses a board to ride on the forward section, or face, of a moving wave of water, which usually carries the surfer towards the shore.`,
				keywords	: `surfing`
			},
			{
				title 		: `Laser Tag`,
				description : `Laser tag is suitable for both adults and children, making it an ideal hobby for people of all ages to enjoy with friends or family members. In years gone by, the term "laser tag" was synonymous with the indoor version, usually comprising close-quarters environments.`,
				keywords	: `laser tag`
			},
			{
				title 		: `Video Games`,
				description : `Video games are indeed considered a hobby, since you play them in your free time. As a matter of fact, anything you do in your free time that you enjoy doing can be considered a hobby.`,
				keywords	: `video games`
			},
			{
				title 		: `Windsurfing`,
				description : `Windsurfing is a surface water sport that is a combination of surfing and sailing. It is also referred to as "sailboarding" and "boardsailing", and emerged in the late 1960s from the surf culture of California.`,
				keywords	: `windsurfing`
			},
			{
				title 		: `Swimming`,
				description : `Swimming is considered as the perfect hobby to have because of its innumerable benefits physically as well as mentally. Any person of any age can enjoy swimming as swimming will not indulge you in a heavy duty work out.`,
				keywords	: `swimming`
			},
			{
				title 		: `Scuba Diving`,
				description : `This hobby enables you to experience the beauty of the underwater environment which comprises of an ecosystem which is much more profound and enormous than that of the land. It is always advisable to take training for scuba driving.`,
				keywords	: `scuba diving`
			},
			{
				title 		: `Paintball`,
				description : `Choosing paintball as a hobby is a great way to get exercise, improve your mind, and have fun all at the same time. It strengthens you in various ways and can teach some valuable life lessons.`,
				keywords	: `paintball`
			},
			{
				title 		: `Drone Flying`,
				description : `Essentially, a drone is a flying robot that can be remotely controlled. If you want to take videos and pictures with minimal skill, or just fly around with minimal skill, then give drones a try.`,
				keywords	: `drone flying`
			},
			{
				title 		: `Trail Running`,
				description : `Trail running is a sport-activity which combines running, and, where there are steep gradients, hiking, that is run "on any unpaved surface". It is similar to both mountain and fell running.`,
				keywords	: `trail running`
			},
			{
				title 		: `Competitive Eating`,
				description : `Competitive eating, or speed eating, is an activity in which participants compete against each other to eat large quantities of food, usually in a short time period.`,
				keywords	: `competitive eating`
			},
			{
				title 		: `Traveling`,
				description : `Travel is the movement of people between distant geographical locations. Travel can be done by foot, bicycle, automobile, train, boat, bus, airplane, ship or other means, with or without luggage, and can be one way or round trip.`,
				keywords	: `traveling`
			},
			{
				title 		: `Wakeboarding`,
				description : `A wakeboard skier works on many of the same principles as a water skier. They are both pulled behind a boat or conveyance. The speed needed will roughly be 18 to 24 miles per hour.`,
				keywords	: `wakeboarding`
			},
			{
				title 		: `Water Ski`,
				description : `Water Skiing is one of the most exhilarating water sports, but beyond rush of adrenaline, there are a number of wonderful health benefits to taking up waterskiing as a hobby.`,
				keywords	: `water ski`
			},
			{
				title 		: `Wingsuit Flying`,
				description : `Different strokes for different folks, basically. The idea of wingsuit flying is that it gives a person the sense of true and free flying, without anything around them, or anything guiding them.`,
				keywords	: `wingsuit flying`
			},
			{
				title 		: `Fire Poi`,
				description : `Fire poi use wicks made from Kevlar or Technora or another flame resistant material for the weighted ends. The wicks are soaked in fuel, set on fire, and then spun for dramatic effect.`,
				keywords	: `fire Poi`
			},
			{
				title 		: `Learning Sign Language`,
				description : `American Sign Language is a natural language that serves as the predominant sign language of Deaf communities in the United States and most of Anglophone Canada. ASL is a complete and organized visual language that is expressed by facial expression as well as movements and motions with the hands.`,
				keywords	: `sign language`
			},
			{
				title 		: `Sandboarding`,
				description : `Sand boarding itself consists of a person riding a board down an inclined surface of sand. These naturally form as dunes in nature. The board can have bindings or not.`,
				keywords	: `sandboarding`
			},
			{
				title 		: `River Rafting`,
				description : `River Rafting is an activity in which you descend in rivers on an inflatable raft, is practiced in the natural spaces that contain river flows, rafting can be considered an extreme activity sport because it is only practiced in cloudy rivers that manifest strong currents.`,
				keywords	: `river rafting`
			},
			{
				title 		: `Running`,
				description : `Running is a hobby, and in fact, it's one of the most versatile, beneficial hobbies you could have. Running is not only exercise, but it provides a way to relieve stress and improve your mood.`,
				keywords	: `running`
			},
			{
				title 		: `Rapping`,
				description : `Rapping is a musical form of vocal delivery that incorporates "rhyme, rhythmic speech, and street vernacular", which is performed or chanted in a variety of ways, usually over a backing beat or musical accompaniment. The components of rap include "content", "flow", and "delivery".`,
				keywords	: `rapping`
			},
			{
				title 		: `Parkour - Freerunning`,
				description : `Parkour is the physical hobby of being able to overcome any obstacle in your path by adapting your movements to the environment. This hobby originated in france and is about moving around objects in the most efficient form possible.`,
				keywords	: `parkour`
			},
			{
				title 		: `Parachuting`,
				description : `Parachuting, including also skydiving, is a method of transiting from a high point in the atmosphere to the surface of Earth with the aid of gravity, involving the control of speed during the descent using a parachute or parachutes.`,
				keywords	: `parachuting`
			},
			{
				title 		: `Boomerangs`,
				description : `Boomerangs offer more than just a fun outdoor activity. Flying a boomerang in the park or on the beach can provide both a meditative and cathartic outlet during this time. You get to switch off from the world as you watch your wooden boomerang glide.`,
				keywords	: `boomerang`
			},
			{
				title 		: `Go Kart Racing`,
				description : `Go karting is a kind of sport almost everyone is fond of either girls or boys, adults or children. Go-karting has set some new trends and left the bumper cars far behind in their speed and precision as well.`,
				keywords	: `go kart`
			},
			{
				title 		: `Lacrosse`,
				description : `Lacrosse is a team sport played with a lacrosse stick and a lacrosse ball. It is the oldest organized sport in North America, with its origins in indigenous Canada as early as the 17th century.`,
				keywords	: `lacrosse`
			},
			{
				title 		: `Starting A Band`,
				description : `Apart from having a myriad of health-related benefits, the sheer enjoyment music is able to bring to one's life is more than enough reason to making music your hobby.`,
				keywords	: `band`
			},
			{
				title 		: `Wrestling`,
				description : `Wrestlers as a hobby during the course of their training & competition are often subject to physical discomfort and sometimes real pain at a level which far exceeds most sports hobbies.`,
				keywords	: `wrestling`
			},
			{
				title 		: `Ziplin`,
				description : `A zip-line, zip line, zip-wire, or zip-power-line is a pulley suspended on a cable, usually made of stainless steel, mounted on a slope.`,
				keywords	: `ziplin`
			},
			{
				title 		: `Field Hockey`,
				description : `Many people play Field Hockey as a Hobby. In fundamental terms, hockey is a two-team sport which sees each team using curved sticks to maneuver a small hard ball about the pitch - the ultimate goal being to get the ball to the goal.`,
				keywords	: `field hockey`
			},
			{
				title 		: `Rugby`,
				description : `Rugby is one of the most popular sports around, but like other sports, professional players have a lot of free time to contend with after training sessions and games. Therefore, taking up a hobby or having an interest or two is crucial.`,
				keywords	: `rugby`
			},
			{
				title 		: `Flag Football`,
				description : `Flag football is a variant of American football where, instead of tackling players to the ground, the defensive team must remove a flag or flag belt from the ball carrier to end a down, and contact is not permitted between players.`,
				keywords	: `flag football`
			},
			{
				title 		: `Beach Volleyball`,
				description : `Beach volleyball as a hobby is pretty fun to do especially because of you can be together with your friends and have fun together. For women, this is a good time to show off your bikini and good skin.`,
				keywords	: `beach volleyball`
			},
			{
				title 		: `Writing Letters`,
				description : `Letter writing offers us so many things at once, a more thoughtful and tactile form of communication, a form of gift-giving that shows someone time was spent in thinking of them, a physical memory one can keep for years, and even an art form.`,
				keywords	: `letter writing`
			},
			{
				title 		: `Knife Throwing`,
				description : `Knife throwing is an art, sport, combat skill, or variously an entertainment technique, involving an artist skilled in the art of throwing knives, the weapons thrown, and a target.`,
				keywords	: `knife throwing`
			},
			{
				title 		: `Skimboarding`,
				description : `Skimboarding or skimming is a boardsport in which a skimboard is used to glide across the water's surface to meet an incoming breaking wave, and ride it back to shore. Wave-riding skimboarders perform a variety of surface.`,
				keywords	: `skimboarding`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Your30s,
			name 			: `For Your 30's`,
			icon 			: {
				style 		: 'solid',
				name 		: `award`
			}
		},
		hobbies 	: [
			{
				title 		: `Dragon Boat Racing`,
				description : `A dragon boat is a human-powered watercraft originating from the Pearl River Delta region of China's southern Guangdong Province. These were made of teak, but in other parts of China, different kinds of wood are used.`,
				keywords	: `dragon boat`
			},
			{
				title 		: `Cross Country Running`,
				description : `Cross country running is a sport in which teams and individuals run a race on open-air courses over natural terrain such as dirt or grass.`,
				keywords	: `cross country running`
			},
			{
				title 		: `Fell Running`,
				description : `Fell running, also sometimes known as hill running, is the sport of running and racing, off-road, over upland country where the gradient climbed is a significant component of the difficulty.`,
				keywords	: `fell running`
			},
			{
				title 		: `Track Cycling`,
				description : `Track cycling is a bicycle racing sport usually held on specially built banked tracks or velodromes using purpose-designed track bicycles.`,
				keywords	: `track cycling`
			},
			{
				title 		: `Surf Lifesaving`,
				description : `Surf lifesaving is a multifaceted social movement that comprises key aspects of voluntary lifeguard services and competitive surf sport. Originating in early 20th century Australia, the movement has expanded globally to other countries.`,
				keywords	: `surf lifesaving`
			},
			{
				title 		: `Photography`,
				description : `It allows you to share your life and experiences in meaningful ways, and it allows you to engage and have fun with other people. Photography is a hobby that offers so many possibilities for creative expression and technical expertise.`,
				keywords	: `photography`
			},
			{
				title 		: `Blacksmithing`,
				description : `A blacksmith is a metalsmith who creates objects primarily from wrought iron or steel, but sometimes from other metals, by forging the metal, using tools to hammer, bend, and cut.`,
				keywords	: `blacksmithing`
			},
			{
				title 		: `Mountaineering`,
				description : `Mountaineering is a lifelong philosophy rather than a mere hobby. Unlike most other extreme sports, mountaineering is uniquely suited to be a lifelong hobby rather than a one-time experience.`,
				keywords	: `mountaineering`
			},
			{
				title 		: `Backpacking`,
				description : `Many of us enjoy going out for trips and vacations. Usually we take a flight to the destination, take a cab from the airport to a starred hotel, there we rest for some time, rent a car and go to the beach or the mountains.`,
				keywords	: `backpacking`
			},
			{
				title 		: `Sports Refereeing`,
				description : `A sports referee is someone who presides over competitive athletic or sporting events. During the event, they will detect infractions and decide penalties according to the rules of the game.`,
				keywords	: `sports referee`
			},
			{
				title 		: `Horse Riding`,
				description : `Horse riding as hobby can be enjoyable for adults, but it is also a very wonderful hobby for children. Children can learn many things about life through horseback riding.`,
				keywords	: `horse riding`
			},
			{
				title 		: `Skydiving / Parachuting`,
				description : `Parachuting, including also skydiving, is a method of transiting from a high point in the atmosphere to the surface of Earth with the aid of gravity, involving the control of speed during the descent using a parachute or parachutes.`,
				keywords	: `parachuting`
			},
			{
				title 		: `Cave Diving`,
				description : `Cave diving is underwater diving in water-filled caves. It may be done as an extreme sport, a way of exploring flooded caves for scientific investigation, or for the search for and recovery of divers lost as a result of one of these activities.`,
				keywords	: `cave diving`
			},
			{
				title 		: `Papermaking`,
				description : `Currently recycling paper is more than a hobby; it is a way to take care of our planet. This craftwork that goes from the design of cards and envelopes to original objects modeled with paper has very good acceptance in the market, which makes it a good job.`,
				keywords	: `papermaking`
			},
			{
				title 		: `Tour Skating`,
				description : `Tour skating is recreational long distance ice skating on natural ice. It is particularly popular in the Netherlands and the Nordic countries. It is becoming more popular in areas of North America such as New England, Southcentral Alaska, and Nova Scotia.`,
				keywords	: `tour skating`
			},
			{
				title 		: `Skiing`,
				description : `Skiing is generally easy to learn initially but is harder to master. Snowboarding is harder to learn but reaching an advanced level is easier. Although there are exceptions to this rule.`,
				keywords	: `skiing`
			},
			{
				title 		: `Snowboarding`,
				description : `Snowboards are boards where a person places both feet, usually secured, to the same board. The board itself is wider than most skis, with the ability to glide on snow.`,
				keywords	: `snowboarding`
			},
			{
				title 		: `Home Brewing`,
				description : `Homebrewing is one of the fastest-growing hobbies in the United States and most people that make their own beer find it to be a rewarding and positive experience that can even save money over time.`,
				keywords	: `homebrewing`
			},
			{
				title 		: `Furniture Making`,
				description : `Woodworking has hundreds of projects that you can work on that suit different skill levels and interests. It is very possible that you will start with working and never do the same Project twice.`,
				keywords	: `woodworking`
			},
			{
				title 		: `Metal Detecting`,
				description : `Metal detecting / treasure hunting is an amazing hobby that offers everything seniors need to stay sharp and mentally active. It activates the imagination and requires problem solving, patience and perseverance.`,
				keywords	: `metal detecting`
			},
			{
				title 		: `Geocaching`,
				description : `Geocaching is an outdoor recreational activity, in which participants use a Global Positioning System receiver or mobile device and other navigational techniques to hide and seek containers, called "geocaches" or "caches", at specific locations.`,
				keywords	: `geocaching`
			},
			{
				title 		: `Treasure Hunting`,
				description : `Treasure hunting is the physical search for treasure. For example, treasure hunters try to find sunken shipwrecks and retrieve artifacts with market value. This industry is generally fueled by the market for antiquities.`,
				keywords	: `treasure hunting`
			},
			{
				title 		: `Glass Blowing`,
				description : `Glassblowing is a glassforming technique that involves inflating molten glass into a bubble with the aid of a blowpipe. A person who blows glass is called a glassblower, glassmith, or gaffer.`,
				keywords	: `glassblowing`
			},
			{
				title 		: `Mountain Biking`,
				description : `Mountain biking is a sport of riding bicycles off-road, often over rough terrain, usually using specially designed mountain bikes.`,
				keywords	: `mountain biking`
			},
			{
				title 		: `Collecting Comic Books`,
				description : `Comic book collecting is a hobby that treats comic books and related items as collectibles or artwork to be sought after and preserved.`,
				keywords	: `comic book collector`
			},
			{
				title 		: `Speed Reading`,
				description : `Speed reading is any of many techniques claiming to improve one's ability to read quickly. Speed-reading methods include chunking and minimizing subvocalization. The many available speed-reading training programs may utilize books, videos, software, and seminars.`,
				keywords	: `speed reading`
			},
			{
				title 		: `Snowmobiling`,
				description : `Snowmobile, also known as a Ski-Doo, snowmachine, sled, motor sled, motor sledge, skimobile, or snow scooter, is a motorized vehicle designed for winter travel and recreation on snow.`,
				keywords	: `snowmobiling`
			},
			{
				title 		: `Shark Diving`,
				description : `Shark cage diving is underwater diving or snorkeling where the observer remains inside a protective cage designed to prevent sharks from making contact with the divers. Shark cage diving is used for scientific observation, underwater cinematography, and as a tourist activity.`,
				keywords	: `shark diving`
			},
			{
				title 		: `Pyrotechnics`,
				description : `Pyrotechnics is the science and craft of creating such things as fireworks, safety matches, oxygen candles, explosive bolts and other fasteners, parts of automotive airbags, as well as gas-pressure blasting in mining, quarrying, and demolition.`,
				keywords	: `pyrotechnics`
			},
			{
				title 		: `Painting`,
				description : `Pursuing a hobby like painting is more about overcoming inhibitions than creating a picture - It takes practice, experience and observation. Painting can stimulate your imagination, inspiring you to explore how you interpret the world.`,
				keywords	: `painting`
			},
			{
				title 		: `Letterboxing`,
				description : `Letterboxing is an outdoor hobby that combines elements of orienteering, art, and puzzle solving. These people hide small, weatherproof boxes in publicly accessible places (like parks) and distribute clues to finding the box in printed catalogs.`,
				keywords	: `letterboxing`
			},
			{
				title 		: `Hang Gliding`,
				description : `Hang gliding is an air sport or recreational activity in which a pilot flies a light, non-motorised foot-launched heavier-than-air aircraft called a hang glider.`,
				keywords	: `hang gliding`
			},
			{
				title 		: `Croquet`,
				description : `Croquet is a sport that involves hitting wooden or plastic balls with a mallet through hoops embedded in a grass playing court. Its international governing body is the World Croquet Federation.`,
				keywords	: `croquet`
			},
			{
				title 		: `Aircraft Spotting`,
				description : `Aircraft spotting or plane spotting is a hobby of tracking the movement of aircraft, which is often accomplished by photography.`,
				keywords	: `aircraft spotting`
			},
			{
				title 		: `Fly Tying`,
				description : `Fly tying is the process of producing an artificial fly used by fly fishing anglers to catch fish. Fly tying is a manual process done by a single individual using hand tools and a variety of natural and manmade materials that are attached to a hook.`,
				keywords	: `fly tying`
			},
			{
				title 		: `Herping`,
				description : `Herping is the act of searching for amphibians or reptiles. The term, often used by professional and amateur herpetologists, comes from the word "herp", which comes from the same Greek root as herpetology, meaning "creeping".`,
				keywords	: `herping`
			},
			{
				title 		: `Becoming A Rail Fan`,
				description : `A railfan, rail buff or train buff (American English), railway enthusiast or railway buff (Australian/British English), trainspotter or ferroequinologist is a person interested, especially recreationally, in rail transport.`,
				keywords	: `railfan`
			},
			{
				title 		: `Slack Lining`,
				description : `Slacklining is a great way to enjoy downtime at your campsite, just like it first filled the time between climbs for 70s dirtbags at the crag. Stretch your muscles, use your body in a new way, and swap stories.`,
				keywords	: `slacklining`
			},
			{
				title 		: `Building Tesla Coils`,
				description : `Builders of Tesla coils as a hobby are called "coilers". They attend "coiling" conventions where they display their home-made Tesla coils and other high voltage devices.`,
				keywords	: `tesla coil`
			},
			{
				title 		: `Motorcycling`,
				description : `Motorcycling is the act of riding a motorcycle. For some people, motorcycling may be the only affordable form of motorized transportation and for others in developed country their favorite hobby.`,
				keywords	: `motorcycling`
			},
			{
				title 		: `Dumpster Diving`,
				description : `Dumpster diving is salvaging from large commercial, residential, industrial and construction containers for unused items discarded by their owners but deemed useful to the picker.`,
				keywords	: `dumpster diving`
			},
			{
				title 		: `Falconry`,
				description : `Falconry is the hunting of wild animals in their natural state and habitat by means of a trained bird of prey. Small animals are hunted; squirrels and rabbits often fall prey to these birds.`,
				keywords	: `falconry`
			},
			{
				title 		: `Hot Air Ballooning`,
				description : `Hot air ballooning is the activity of flying hot air balloons. Attractive aspects of ballooning include the exceptional quiet (except when the propane burners are firing).`,
				keywords	: `hot air ballooning`
			},
			{
				title 		: `Dog Sport`,
				description : `Agility is a sport for you and your dog. Like any sport, also agility can be trained and competed at different levels. It can be a nice shared hobby for you and your dog in your free time or you can compete more seriously.`,
				keywords	: `dog sport`
			},
			{
				title 		: `Bicycle Polo`,
				description : `Cycle polo is a team sport, similar to traditional polo, except that bicycles are used instead of horses. There are two versions of the sport: grass and Hardcourt Bike Polo.`,
				keywords	: `bicycle polo`
			},
			{
				title 		: `Sand Art`,
				description : `Sand art is a creative and fun hobby that anyone can do. There are different types of sand art drawings from simple shapes in the sand to more complex designs like animals or people.`,
				keywords	: `sand art`
			},
			{
				title 		: `Sculling Or Rowing`,
				description : `Basically this activity is related to the natural spaces with nautical attributes, that is to say, that the element water is present. The activities related to rowing have existed since before even Christ, as the natives needed to move by rafts, for fishing.`,
				keywords	: `sculling`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Retired,
			name 			: `Over 50/Retired`,
			icon 			: {
				style 		: 'solid',
				name 		: `glasses`
			}
		},
		hobbies 	: [
			{
				title 		: `Astronomy`,
				description : `Looking at the stars, finding planets, checking out constellations, watching shooting stars! Looking upward is a lot of fun, and it's free. The hard part is getting started and knowing what to look for.`,
				keywords	: `astronomy`
			},
			{
				title 		: `Outrigger Canoe Racing`,
				description : `Outrigger Canoeing is a racing sport of the canoeing discipline in which canoes with lateral floats called outriggers fastened to the hull is used for racing. There are also long distance races.`,
				keywords	: `canoe racing`
			},
			{
				title 		: `Kicksled`,
				description : `The kicksled or spark is a small sled consisting of a chair mounted on a pair of flexible metal runners that extend backward to about twice the chair's length. The sled is propelled by kicking the ground by foot.`,
				keywords	: `kicksled`
			},
			{
				title 		: `Skijoring`,
				description : `Skijoring is a winter sport in which a person on skis is pulled by a horse, a dog or a motor vehicle. It is derived from the Norwegian word skikjoring, meaning "ski driving".`,
				keywords	: `skijoring`
			},
			{
				title 		: `Kinetic Sculpture Racing`,
				description : `Kinetic sculpture races are organized contests of human-powered amphibious all-terrain works of art. The original cross country event.`,
				keywords	: `kinetic sculpture races`
			},
			{
				title 		: `Polo`,
				description : `Hobby horse polo is a mixed team sport played on hobby horses. It is similar to other polo variants, such as canoe polo, cycle polo, camel polo, elephant polo, golfcart polo, Segway polo, auto polo, and yak polo in that it uses the basic polo rules, but it has its own specialities.`,
				keywords	: `polo`
			},
			{
				title 		: `Leather Making`,
				description : `Leatherworking is the perfect hobby. Making your own leather goods as a hobby is the basic idea. It's a blend of physical and mental focus that is unique.`,
				keywords	: `leatherworking`
			},
			{
				title 		: `Rock & Mineral Collecting`,
				description : `Nature has a ton of beauty, and for those with a collector spirit, rock collecting can be a fun, free hobby. The hard part about collecting in general is that it can be expensive. Want to collect coins?`,
				keywords	: `mineral collecting`
			},
			{
				title 		: `Collecting Sea Glass`,
				description : `Collecting Sea Glass can be collected as a hobby and is used for decoration, most commonly in jewelry. "Beach glass" comes from fresh water and is often less frosted in appearance than sea glass.`,
				keywords	: `sea glass collecting`
			},
			{
				title 		: `Woodburning`,
				description : `Wood burning can be a fun way to develop your artistic skills, as you learn to decorate and brand various objects from kitchenware to tools. Burning designs into wood begins with having the right tools.`,
				keywords	: `woodburning`
			},
			{
				title 		: `Whale Watching`,
				description : `Whale watching is an act of observing whales same as bird watching in their natural habitat. Whale watching as a hobby involves standing at the boat deck at the end as spectators with binoculars and watching whales as they live their undisturbed lives.`,
				keywords	: `whale watching`
			},
			{
				title 		: `Gardening`,
				description : `Gardening requires you to do so many activities like pruning, digging, watering the plants, bending, etc. So that makes it a pretty good workout regime as well. Research shows that 3 hours of moderate gardening is equivalent to 1 hour in the gym.`,
				keywords	: `gardening`
			},
			{
				title 		: `Golf`,
				description : `Golf is a club-and-ball sport in which players use various clubs to hit balls into a series of holes on a course in as few strokes.`,
				keywords	: `golf`
			},
			{
				title 		: `Art Collecting`,
				description : `Collecting is a fun hobby, and one of the most interesting things to collect are art collectibles. Many different items can be painted with artwork and become an art collectible. Hobby enthusiasts collect such things as saw blades, and wooden eggs which have had artwork painted on.`,
				keywords	: `art collecting`
			},
			{
				title 		: `Food Preservation (Pickling, Canning)`,
				description : `If you want to enjoy your fruit and veggies long after they've been harvested, canning is one tried-and-true option. Canning food is a preservation method that allows you to turn fresh produce into shelf-stable food that you can store for a year or more.`,
				keywords	: `food preservation`
			},
			{
				title 		: `Using Ham Radio`,
				description : `Amateur Radio (ham radio) is a popular hobby and service that brings people, electronics and communication together. People use ham radio to talk across town, around the world, or even into space.`,
				keywords	: `ham radio`
			},
			{
				title 		: `Coin Collecting`,
				description : `A person who collects and studies coins or paper money is called a numismatist. Though coin collecting dates back to ancient Rome, it wasn't popular until the Renaissance in the 13th century.`,
				keywords	: `coin collecting`
			},
			{
				title 		: `Record Collecting`,
				description : `Record collecting is the hobby of collecting sound recordings, usually of music, but sometimes poetry, reading, historical speeches, and ambient noises. Although the typical focus is on vinyl records, all formats of recorded music can be collected.`,
				keywords	: `record collecting`
			},
			{
				title 		: `Being A History Buff`,
				description : `Being a history buff is about having fun and making history a hobby, so you will want to start off by learning all you can about the time periods that most interest you. Your list can be as long or short as you want.`,
				keywords	: `history buff`
			},
			{
				title 		: `Farming`,
				description : `Farming can be someone's profession, but it can also be a hobby that brings them great joy. When you hobby farm, you're growing your own food, and these are typically healthy vegetables and animal products.`,
				keywords	: `farming`
			},
			{
				title 		: `Growing Bonsais`,
				description : `Training and tending a bonsai tree is stress-free, rewarding hobby that does not have to be done in a hurry. Growing bonsai is a chance to relax your grip, step back and enjoy the natural beauty of plant life from the comfort of your own home.`,
				keywords	: `growing bonsais`
			},
			{
				title 		: `Meteorology`,
				description : `You probably haven't even thought about weather as a hobby. However, every time you make conscious note of your local weather patterns, or go take special interest in the local or regional weather events, yo are essentially engaging in weather as a hobby.`,
				keywords	: `meteorology`
			},
			{
				title 		: `Cartography`,
				description : `Cartography is the study and practice of making and using maps. Combining science, aesthetics and technique, cartography builds on the premise that reality can be modeled in ways that communicate spatial information effectively.`,
				keywords	: `cartography`
			},
			{
				title 		: `Taxidermy`,
				description : `Art From Death: Taxidermy As A Creative Hobby From DIY stuffing kits to workshops and homemade skull jewelry, this old craft is getting a revival from the hands of artists, designers and newcomers determined to make stuffing the dead trendy.`,
				keywords	: `taxidermy`
			},
			{
				title 		: `Astrology`,
				description : `Astrology is a pseudoscience that claims to discern information about human affairs and terrestrial events by studying the movements and relative positions of celestial objects.`,
				keywords	: `astrology`
			},
			{
				title 		: `Cryptography`,
				description : `Cryptography, or cryptology, is the practice and study of techniques for secure communication in the presence of adversarial behavior.`,
				keywords	: `cryptography`
			},
			{
				title 		: `Graphology`,
				description : `Graphology is the analysis of handwriting with attempt to determine someone's personality traits. No scientific evidence exists to support graphology, and it is generally considered a pseudoscience or scientifically questionable practice.`,
				keywords	: `graphology`
			},
			{
				title 		: `Tea Drinking`,
				description : `Tea is an aromatic beverage prepared by pouring hot or boiling water over cured or fresh leaves, an evergreen shrub native to China and other East Asian countries.`,
				keywords	: `tea drinking`
			},
			{
				title 		: `Fishing`,
				description : `Fishing is the activity of trying to catch fish. Fish are often caught in the wild but may also be caught from stocked bodies of water.`,
				keywords	: `fishing`
			},
			{
				title 		: `Tai Chi`,
				description : `Tai Chi is a martial art with therapeutic applications originating in the Chinese Empire, and whose practice is related to the achievement of greater physical and psychic balance.`,
				keywords	: `tai chi`
			},
			{
				title 		: `Palm Reading`,
				description : `Palm reading is a captivating hobby that lets you read the character and destiny by observing the hand. The palm is practically a blueprint of our life and by knowing how to read it you can actually influence the destiny.`,
				keywords	: `palm reading`
			},
			{
				title 		: `Music Memorabilia`,
				description : `Besides being a hobby, collection of music memorabilia is also a part and parcel of any connoisseur's life. Collectibles can include audiotapes, records and CDs from all over the world.`,
				keywords	: `music memorabilia`
			},
			{
				title 		: `Butterfly Watching`,
				description : `Butterfly watching is a hobby concerned with the observation and study of butterflies. It also includes the "catch and release" of butterflies. There are clubs, handbooks, checklists, and festivals devoted to the activity.`,
				keywords	: `butterfly watching`
			},
			{
				title 		: `Gyotaku`,
				description : `Gyotaku is the traditional Japanese method of printing fish, a practice which dates back to the mid-1800s. This form of nature printing was used by fishermen to record their catches, but has also become an art form of its own.`,
				keywords	: `gyotaku`
			},
			{
				title 		: `Trainspotting`,
				description : `Trainspotting is the practice of watching trains, particularly as a hobby, with the aim of noting distinctive characteristics.`,
				keywords	: `trainspotting`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Fun,
			name 			: `Fun`,
			icon 			: {
				style 		: 'solid',
				name 		: `masks-theater`
			}
		},
		hobbies 	: [
			{
				title 		: `Cloud Watching`,
				description : `Cloud watching is a fun hobby for children and adults alike. It is also one of the few hobbies that can be done without any equipment - just some spare time and a little imagination!`,
				keywords	: `cloud watching`
			},
			{
				title 		: `Deltiology`,
				description : `Deltiology is the study and collection of postcards. Professor Randall of Ashland, Ohio, coined a word in 1945 that became the accepted description of the study of picture postcards.`,
				keywords	: `deltiology`
			},
			{
				title 		: `Antiquing`,
				description : `Many people look for antiques or collectibles as a hobby, but they seldom buy anything. They simply enjoy looking at what different areas of the country have to offer. In addition to being profitable, it can be a lot of fun and an enjoyable pastime to search through antique stores.`,
				keywords	: `antiquing`
			},
			{
				title 		: `Brewing Beer`,
				description : `Homebrewing is one of the fastest-growing hobbies in the United States and most people that make their own beer find it to be a rewarding and positive experience that can even save money over time.`,
				keywords	: `brewing beer`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Cool,
			name 			: `Cool`,
			icon 			: {
				style 		: 'solid',
				name 		: `ice-cream`
			}
		},
		hobbies 	: [
			{
				title 		: `Leaf Collecting And Pressing`,
				description : `Pressing leaves with weight is the simplest method of saving fall leaves, but the leaves won't last as long as other preservation methods. For pressing, choose leaves that are flat and thin with a low moisture content, and collect some of your heaviest books.`,
				keywords	: `leaf collecting`
			},
			{
				title 		: `Carpet Weaving`,
				description : `Hand-knotted Indian carpets are made on specially designed looms in a carpet factory. In this technique, once a particular design for the rug is decided, the rug is placed on the loom.`,
				keywords	: `carpet weaving`
			},
			{
				title 		: `Fantasy Sports`,
				description : `Fantasy sports as a hobby have always given much play in the electronic entertainment industry. With so much diversity of disciplines, the genre has been nourished from reality to create from simulators with real sportsmen to very crazy games of arcade development and full of fantasy.`,
				keywords	: `fantasy sports`
			},
			{
				title 		: `Improv`,
				description : `Improvisational theatre, often called improvisation or improv, is the form of theatre, often comedy, in which most or all of what is performed is unplanned or unscripted. Improv isn't just any hobby.`,
				keywords	: `improv`
			},
			{
				title 		: `Chandlery`,
				description : `A chandlery was originally the office in a wealthy medieval household responsible for wax and candles, as well as the room in which the candles were kept. It could be headed by a chandler.`,
				keywords	: `chandlery`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Unique,
			name 			: `Unique`,
			icon 			: {
				style 		: 'solid',
				name 		: `thumbs-up`
			}
		},
		hobbies 	: [
			{
				title 		: `Wheel Throwing`,
				description : `This is known as throwing pottery. Some pottery wheels are designed so that you can stand at them. Most are designed so that you can sit at them whilst you work.`,
				keywords	: `wheel throwing`
			},
			{
				title 		: `Silver Making`,
				description : `Designing wire jewelry is very popular and many people have turned this into a lucrative hobby. Wire is especially easy for beginners to work with. Basically a hobby on making wire jewelry.`,
				keywords	: `silver making`
			},
			{
				title 		: `Sky Diving`,
				description : `Parachuting, including also skydiving, is a method of transiting from a high point in the atmosphere to the surface of Earth with the aid of gravity, involving the control of speed during the descent using a parachute or parachutes.`,
				keywords	: `sky diving`
			},
			{
				title 		: `Tattoo Designing`,
				description : `Creating tattoos is a unique design challenge. With a curved canvas and complex tools, these designs need to follow specific rules to look good in the long term. Creating a design you're comfortable tattooing will ensure that it looks beautiful.`,
				keywords	: `tattoo designing`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.ForWomen,
			name 			: `For Women`,
			icon 			: {
				style 		: 'solid',
				name 		: `person-dress`
			}
		},
		hobbies 	: [
			{
				title 		: `Vinyl Collecting`,
				description : `Record collecting is the hobby of collecting sound recordings, usually of music, but sometimes poetry, reading, historical speeches, and ambient noises. Although the typical focus is on vinyl records, all formats of recorded music can be collected.`,
				keywords	: `vinyl collecting`
			},
			{
				title 		: `Board Surfing`,
				description : `A surfboard is a narrow plank used in surfing. Surfboards are relatively light, but are strong enough to support an individual standing on them while riding an ocean wave.`,
				keywords	: `board surfing`
			},
			{
				title 		: `Digital Scrapbooking`,
				description : `Digital scrapbooking is the term for the creation of a new 2D artwork by re-combining various graphic elements. It is a form of scrapbooking that is done using a personal computer, digital or scanned photos and computer graphics software.`,
				keywords	: `scrapbooking`
			},
			{
				title 		: `Karate`,
				description : `Karate is a martial art developed in the Ryukyu Kingdom. It developed from the indigenous Ryukyuan martial arts under the influence of Chinese martial arts, particularly Fujian White Crane.`,
				keywords	: `karate`
			},
			{
				title 		: `Cake Decorating`,
				description : `Cake decorating is one of the sugar arts that uses icing, frosting, and other edible decorative elements to make plain cakes more visually interesting.`,
				keywords	: `cake decorating`
			},
			{
				title 		: `Cookie Decorating`,
				description : `Cookie decorating are decorating bags, decorating tips, a scribe tool or a toothpick to help spread the icing on the cookie, and bag ties or rubber bands to help keep the icing from spilling out the back of the bag.`,
				keywords	: `cookie decorating`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Creative,
			name 			: `Creative`,
			icon 			: {
				style 		: 'solid',
				name 		: `handshake`
			}
		},
		hobbies 	: [
			{
				title 		: `Star Watching`,
				description : `Stargazing is a simple and satisfying outdoor hobby. It's educational yet relaxing at the same time, and all people from all walks of life can enjoy it. Some hobbyist stargazers and amateur astronomers have even made important discoveries.`,
				keywords	: `stargazing`
			},
			{
				title 		: `Air Gardening`,
				description : `Air gardening is an easy way to garden. It is simple to do, low maintenance and beautiful.`,
				keywords	: `air gardening`
			},
			{
				title 		: `Freediving`,
				description : `Freediving may be a hobby and not a lifestyle, it is excellent to have something to take your mind off of your normal life and will give you something to look forward to, while also acting as a stress-reliever.`,
				keywords	: `freediving`
			},
			{
				title 		: `Beadwork`,
				description : `Beading is a wonderful hobby for a creative flair, making fun creations that you can even sell to friends, and reduce stress. Stringing beads is an ideal pastime full of fun and comes without spending much.`,
				keywords	: `beadwork`
			},
			{
				title 		: `Quilting`,
				description : `Quilting is a fun, engaging hobby and it's the perfect way to unwind after a stressful day. In addition to being a wonderful way to pass time, quilting allows you to explore your creativity.`,
				keywords	: `quilting`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Interesting,
			name 			: `Interesting`,
			icon 			: {
				style 		: 'solid',
				name 		: `lightbulb-on`
			}
		},
		hobbies 	: [
			{
				title 		: `Latte Art`,
				description : `Latte art shows an appreciation for coffee and attention to detail. It's a visual complement, a final flourish declaring the beverage you hold has been prepared with passion.`,
				keywords	: `latte art`
			},
			{
				title 		: `Music Writing`,
				description : `Writing a song can help with tapping into the source of certain feelings, especially in areas of love and desire, and coming up with possible solutions, which can further relieve tension and stress.`,
				keywords	: `song writing`
			},
			{
				title 		: `Currency Collecting`,
				description : `Coin collecting, also called numismatics, the systematic accumulation and study of coins, tokens, paper money, and objects of similar form and purpose. The collecting of coins is one of the oldest hobbies in the world.`,
				keywords	: `coin collecting`
			}
		]
	},
	{
		category 	: {
			category 		: EnumHobbyCategory.Expensive,
			name 			: `Expensive`,
			icon 			: {
				style 		: 'solid',
				name 		: `money-bill-wave`
			}
		},
		hobbies 	: [
			{
				title 		: `Kayaking`,
				description : `Kayaking is a wonderful outdoor activity, to improve your cardiovascular fitness, increase your body strength, and to become more flexible. While you are using a paddle, it results in a great arm workout and will allow you to have firm looking arms.`,
				keywords	: `kayaking`
			},
			{
				title 		: `Cheese Making`,
				description : `Cheesemaking (or caseiculture) is the craft of making cheese. The production of cheese, like many other food preservation processes, allows the nutritional and economic value of a food material, in this case milk, to be preserved in concentrated form.`,
				keywords	: `cheesemaking`
			},
			{
				title 		: `Nature Painting`,
				description : `Nature paintings also referred to as Landscape or scenery paintings mostly shows references of mountains, trees or other natural elements. From exquisite landscapes to simple depictions of scenery.`,
				keywords	: `nature painting`
			},
			{
				title 		: `Shopping`,
				description : `Shopping as a hobby can be fun, but it brings all sort of problems, not only to the planet but to our personal lives. Money: this is probably the most obvious to most people.`,
				keywords	: `shopping`
			}
		]
	}
];


/**------------------------------------------------------
 * Interfaces Definations
 */
export interface IHobbyList {
	category	: ICategory;
	hobbies		: IHobby[];
}

export interface ICategory {
	category 	: EnumHobbyCategory;
	name 	 	: string;
	icon 	 	: IReferenceIcon;
}

export interface IHobby {
	title 		: string;
	description : string;
	keywords	: string;
}
